import { UIMetadataComplete } from '../../../types/UIMetadata';

// Cast through unknown to allow additional model-level UI fields (e.g., name, specifications)
export const uimetadata = {
  models: {
    Traverse: {
      variants: {
        z71: {
          configurationId: 'd5tbkkfd7k97',
          name: {
            en: 'Z71',
            ar: 'Z71',
          },
          description: {
            en: 'Advanced Twin-Clutch AWD',
            ar: 'نظام الدفع الرباعي المتقدم',
          },
          drivetrain: 'AWD',
          trim: 'Z71',
          highlights: [
            { en: '6.2L V8 engine with 420 HP', ar: 'محرك V8 بسعة 6.2 لتر بقوة 420 حصان' },
            { en: 'Advanced Twin-Clutch All-Wheel Drive', ar: 'نظام الدفع الرباعي المتقدم بقابض مزدوج' },
            { en: 'Z71 Off-Road suspension package', ar: 'حزمة تعليق Z71 للطرق الوعرة' },
          ],
          specs: [
            { en: '6.2L V8 engine', ar: 'محرك V8 بسعة 6.2 لتر' },
            { en: '10-speed automatic transmission', ar: 'ناقل حركة أوتوماتيكي 10 سرعات' },
          ],
          image: 'images/2378/var_Z71.png',
          price: {
            KSA: 189436,
            UAE: 185900,
            OMR: 19701,
            BHD: 19196,
            QAR: 183879,
            JOD: 35867,
            KW: 15660,
            LBP: 50516,
            IQD: 50516,
            default: 185900,
          },
          index: 0,
          isDefault: true,
          autoIntelRPOCode: '2Z7',
          ar: {
            enable: false,
            redirection: false,
          },
          // Set mobile/desktop to false to hide that tab for this variant
          toggleTabs: {
            CONFIG:   { mobile: false,  desktop: false },
            MODEL:    { mobile: true,  desktop: true },
            EXTERIOR: { mobile: true,  desktop: true },
            INTERIOR: { mobile: true,  desktop: true },
            OPTIONS:  { mobile: false,  desktop: false },
            SUMMARY:  { mobile: true,  desktop: true },
          },
          brandItemCode: 'CHTR01',
        },
        lt: {
          name: {
            en: 'LT',
            ar: 'LT',
          },
          description: {
            en: 'AWD',
            ar: 'دفع رباعي',
          },
          drivetrain: 'AWD',
          trim: 'LT',
          highlights: [
            { en: 'Power programmable liftgate', ar: 'باب خلفي كهربائي قابل للبرمجة' },
            { en: 'Available Jet Black, Leather-Appointed seating surfaces', ar: 'مقاعد جلدية فاخرة باللون الأسود النفاث' },
            { en: 'Heated driver and front passenger seats', ar: 'مقاعد أمامية مدفأة للسائق والراكب' },
          ],
          specs: [
            { en: '5.3L V8 engine', ar: 'محرك V8 بسعة 5.3 لتر' },
            { en: '10-speed automatic transmission', ar: 'ناقل حركة أوتوماتيكي 10 سرعات' },
          ],
          image: 'images/2378/var_LT_AWD.png',
          price: {
            KSA: 183933,
            UAE: 180500,
            OMR: 19129,
            BHD: 18639,
            QAR: 178538,
            JOD: 34825,
            KW: 15205,
            LBP: 49049,
            IQD: 49049,
            default: 180500,
          },
          index: 1,
          isDefault: false,
          autoIntelRPOCode: '2LT',
          ar: {
            enable: false,
            redirection: false,
          },
          // Set mobile/desktop to false to hide that tab for this variant
          toggleTabs: {
            CONFIG:   { mobile: false,  desktop: false },
            MODEL:    { mobile: true,  desktop: true },
            EXTERIOR: { mobile: true,  desktop: true },
            INTERIOR: { mobile: true,  desktop: true },
            OPTIONS:  { mobile: true,  desktop: true },
            SUMMARY:  { mobile: true,  desktop: true },
          },
          brandItemCode: 'CHTR02',
        },
        'lt-d5tbgkkfd7k97': {
          configurationId: 'd5tbkkrfd7k97',
          name: {
            en: 'LT',
            ar: 'LT',
          },
          description: {
            en: 'FWD',
            ar: 'دفع أمامي',
          },
          drivetrain: 'FWD',
          trim: 'LT',
          highlights: [
            { en: 'Power programmable liftgate', ar: 'باب خلفي كهربائي قابل للبرمجة' },
            { en: 'Available Jet Black, Leather-Appointed seating surfaces', ar: 'مقاعد جلدية فاخرة باللون الأسود النفاث' },
            { en: 'Efficient front-wheel drive for everyday performance', ar: 'دفع أمامي فعال للأداء اليومي' },
          ],
          specs: [
            { en: '5.3L V8 engine', ar: 'محرك V8 بسعة 5.3 لتر' },
            { en: '10-speed automatic transmission', ar: 'ناقل حركة أوتوماتيكي 10 سرعات' },
          ],
          image: 'images/2378/var_LT_FWD.png',
          price: {
            KSA: 176698,
            UAE: 173400,
            OMR: 18377,
            BHD: 17905,
            QAR: 171515,
            JOD: 33455,
            KW: 14607,
            LBP: 47120,
            IQD: 47120,
            default: 173400,
          },
          index: 2,
          isDefault: false,
          autoIntelRPOCode: '1LT',
          ar: {
            enable: false,
            redirection: false,
          },
          // Set mobile/desktop to false to hide that tab for this variant
          toggleTabs: {
            CONFIG:   { mobile: false,  desktop: false },
            MODEL:    { mobile: true,  desktop: true },
            EXTERIOR: { mobile: true,  desktop: true },
            INTERIOR: { mobile: true,  desktop: true },
            OPTIONS:  { mobile: true,  desktop: true },
            SUMMARY:  { mobile: true,  desktop: true },
          },
          brandItemCode: 'CHTR03',
        },
      },
      backgrounds: {
        g0ZA968_RpUd: {
          image: 'images/2378/Night.png',
          title: {
            en: 'City Landscape',
            ar: 'منظر المدينة',
          },
        },
        g0ZA968_RpUe: {
          image: 'images/2378/desert_2.png',
          title: {
            en: 'Desert Landscape',
            ar: 'المناظر الطبيعية الصحراوية',
          },
        },
      },
      ambientLighting: {},
      colors: {
        interior: {
          tardm9hwgcy55: {
            label: {
              en: 'Jet Black with Torch Red Accents Evotex',
              ar: 'أسود نفاث مع لمسات حمراء شعلة من إيفوتكس',
            },
            image: 'images/2378/colors_new/int/Graystone, Perforated leather seating surfaces.png',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HQC',
            brandItemCode: 'IN32',
          },
          '6zg8oyzi80j9': {
            label: {
              en: 'Jet Black Premium Cloth',
              ar: 'قماش أسود فاخر',
            },
            image: 'images/2378/colors_new/int/LT Jet Black, Premium cloth seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'BAQ',
            brandItemCode: 'IN29',
          },
          aolksf9a8rsg: {
            label: {
              en: 'Jet Black/Gideon Premium Cloth',
              ar: 'قماش فاخر باللون الأسود النفاث/جيديون',
            },
            image: 'images/2378/colors_new/int/Gideon, Premium cloth seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'BAQ',
            brandItemCode: 'IN30',
          },
          ojenkj2t5p54: {
            label: {
              en: 'Jet Black Evotex',
              ar: 'إيفوتكس أسود جيت',
            },
            image: 'images/2378/colors_new/int/LT Jet Black, Evotex seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 2,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HHJ',
            brandItemCode: 'IN31',
          },
          tarm9hwgcy55: {
            label: {
              en: 'Jet Black Premium Cloth',
              ar: 'قماش أسود فاخر',
            },
            image: 'images/2378/colors_new/int/LT Jet Black, Premium cloth seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 0,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'BAQ',
            brandItemCode: 'IN29',
          },
          taqrm9hwgcy55: {
            label: {
              en: 'Jet Black/Gideon Premium Cloth',
              ar: 'قماش فاخر باللون الأسود النفاث/جيديون',
            },
            image: 'images/2378/colors_new/int/Gideon, Premium cloth seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'BAQ',
            brandItemCode: 'IN30',
          },
          taqrm9hwgcy56: {
            label: {
              en: 'Jet Black/Gideon Premium Cloth',
              ar: 'قماش فاخر باللون الأسود النفاث/جيديون',
            },
            image: 'images/2378/colors_new/int/Gideon, Premium cloth seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
            index: 1,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'BAQ',
            brandItemCode: 'IN30',
          },
          tarm9hewgcy55: {
            label: {
              en: 'Jet Black Evotex',
              ar: 'إيفوتكس أسود جيت',
            },
            image: 'images/2378/colors_new/int/LT Jet Black, Evotex seat trim.png',
            usdz: 'interior_red',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 2,
            type: 'interior',
            cardType: 'cart',
            cartImage: '',
            hasQuantity: false,
            autoIntelRPOCode: 'HHJ',
            brandItemCode: 'IN31',
          },
        },
        exterior: {
          '5c8ep1iwg2jn': {
            label: {
              en: 'Polar White Tricoat',
              ar: 'القطبية البيضاء ثلاثية المعطف',
            },
            image: 'images/2378/colors_new/ext/Polar White Tricoat.png',
            usdz: 'red',
            price: {
              KSA: 3739,
              UAE: 3669,
              OMR: 389,
              BHD: 379,
              QAR: 3629,
              JOD: 708,
              KW: 309,
              LBP: 997,
              IQD: 997,
              default: 3669,
            },
            index: 0,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Polar White Tricoat.png',
            hasQuantity: false,
            autoIntelRPOCode: 'G4J',
            brandItemCode: 'EX29',
          },
          sn7yhhtw36la: {
            label: {
              en: 'Mosaic Black Metallic',
              ar: 'موزاييك أسود معدني',
            },
            image: 'images/2378/colors_new/ext/Mosaic Black Metallic.png',
            usdz: 'red_black',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 1,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Mosaic Black Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GB8',
            brandItemCode: 'EX33',
          },
          '0c7b33ow746eu': {
            label: {
              en: 'Radiant Red Tincoat',
              ar: 'طلاء القصدير الأحمر المشع',
            },
            image: 'images/2378/colors_new/ext/Radiant Red Tintcoat.png',
            usdz: 'black',
            price: {
              KSA: 2242,
              UAE: 2200,
              OMR: 233,
              BHD: 227,
              QAR: 2176,
              JOD: 424,
              KW: 185,
              LBP: 598,
              IQD: 598,
              default: 2200,
            },
            index: 2,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Radiant Red Tintcoat.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GNT',
          },
          fa1gr6h4tgwqj: {
            label: {
              en: 'Sterling Gray Metallic',
              ar: 'رمادي استرليني معدني',
            },
            image: 'images/2378/colors_new/ext/Sterling Gray Metallic.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 3,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Sterling Gray Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GXD',
            brandItemCode: 'EX05',
          },
          '8gq4rd16o5mdp': {
            label: {
              en: 'Lakeshore Blue Metallic',
              ar: 'أزرق ليكشور ميتاليك',
            },
            image: 'images/2378/colors_new/ext/Lakeshore Blue Metallic.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 4,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Lakeshore Blue Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GXP',
            brandItemCode: 'EX14',
          },
          nwlfddrqlbg2: {
            label: {
              en: 'Sandstone Gray',
              ar: 'الحجر الرملي الرمادي',
            },
            image: 'images/2378/colors_new/ext/Sandstone Gray.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 5,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Sandstone Gray.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GFR',
            brandItemCode: 'EX34',
          },
          mp3svcxjkf6n: {
            label: {
              en: 'Polar White Tricoat',
              ar: 'القطبية البيضاء ثلاثية المعطف',
            },
            image: 'images/2378/colors_new/ext/Polar White Tricoat.png',
            usdz: 'red',
            price: {
              KSA: 3739,
              UAE: 3669,
              OMR: 389,
              BHD: 379,
              QAR: 3629,
              JOD: 708,
              KW: 309,
              LBP: 997,
              IQD: 997,
              default: 3669,
            },
            index: 0,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Polar White Tricoat.png',
            hasQuantity: false,
            autoIntelRPOCode: 'G4J',
            brandItemCode: 'EX29',
          },
          '8udilr5nuqyd': {
            label: {
              en: 'Mosaic Black Metallic',
              ar: 'موزاييك أسود معدني',
            },
            image: 'images/2378/colors_new/ext/Mosaic Black Metallic.png',
            usdz: 'red_black',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 1,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Mosaic Black Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GB8',
            brandItemCode: 'EX33',
          },
          '0ua46njowdyw': {
            label: {
              en: 'Radiant Red Tincoat',
              ar: 'طلاء القصدير الأحمر المشع',
            },
            image: 'images/2378/colors_new/ext/Radiant Red Tintcoat.png',
            usdz: 'black',
            price: {
              KSA: 2242,
              UAE: 2200,
              OMR: 233,
              BHD: 227,
              QAR: 2176,
              JOD: 424,
              KW: 185,
              LBP: 598,
              IQD: 598,
              default: 2200,
            },
            index: 2,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Radiant Red Tintcoat.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GNT',
          },
          '1a89yotoix4m': {
            label: {
              en: 'Sterling Gray Metallic',
              ar: 'رمادي استرليني معدني',
            },
            image: 'images/2378/colors_new/ext/Sterling Gray Metallic.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 3,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Sterling Gray Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GXD',
            brandItemCode: 'EX05',
          },
          y115ku95mdlo: {
            label: {
              en: 'Lakeshore Blue Metallic',
              ar: 'أزرق ليكشور ميتاليك',
            },
            image: 'images/2378/colors_new/ext/Lakeshore Blue Metallic.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 4,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Lakeshore Blue Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GXP',
            brandItemCode: 'EX14',
          },
          '03qc7azao6jc': {
            label: {
              en: 'Summit White',
              ar: 'القمة البيضاء',
            },
            image: 'images/2378/colors_new/ext/Summit White.png',
            usdz: 'blue',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              KW: 0,
              default: 0,
            },
            index: 5,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Summit White.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GAZ',
            brandItemCode: 'EX01',
          },
          '5wc8ep1iwg2jn': {
            label: {
              en: 'Polar White Tricoat',
              ar: 'القطبية البيضاء ثلاثية المعطف',
            },
            image: 'images/2378/colors_new/ext/Polar White Tricoat.png',
            usdz: 'red',
            price: {
              KSA: 3739,
              UAE: 3669,
              OMR: 389,
              BHD: 379,
              QAR: 3629,
              JOD: 708,
              KW: 309,
              LBP: 997,
              IQD: 997,
              default: 3669,
            },
            index: 0,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Polar White Tricoat.png',
            hasQuantity: false,
            autoIntelRPOCode: 'G4J',
            brandItemCode: 'EX29',
          },
          sn7yhhtsw36la: {
            label: {
              en: 'Mosaic Black Metallic',
              ar: 'موزاييك أسود معدني',
            },
            image: 'images/2378/colors_new/ext/Mosaic Black Metallic.png',
            usdz: 'red_black',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 1,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Mosaic Black Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GB8',
            brandItemCode: 'EX33',
          },
          '0c7b3ow746eu': {
            label: {
              en: 'Radiant Red Tincoat',
              ar: 'طلاء القصدير الأحمر المشع',
            },
            image: 'images/2378/colors_new/ext/Radiant Red Tintcoat.png',
            usdz: 'black',
            price: {
              KSA: 2242,
              UAE: 2200,
              OMR: 233,
              BHD: 227,
              QAR: 2176,
              JOD: 424,
              KW: 185,
              LBP: 598,
              IQD: 598,
              default: 2200,
            },
            index: 2,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Radiant Red Tintcoat.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GNT',
          },
          fa1g6h4tgwqj: {
            label: {
              en: 'Sterling Gray Metallic',
              ar: 'رمادي استرليني معدني',
            },
            image: 'images/2378/colors_new/ext/Sterling Gray Metallic.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 3,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Sterling Gray Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GXD',
            brandItemCode: 'EX05',
          },
          '8gq4d16o5mdp': {
            label: {
              en: 'Lakeshore Blue Metallic',
              ar: 'أزرق ليكشور ميتاليك',
            },
            image: 'images/2378/colors_new/ext/Lakeshore Blue Metallic.png',
            usdz: 'blue',
            price: {
              KSA: 745,
              UAE: 731,
              OMR: 77,
              BHD: 75,
              QAR: 723,
              JOD: 141,
              KW: 62,
              LBP: 199,
              IQD: 199,
              default: 731,
            },
            index: 4,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Lakeshore Blue Metallic.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GXP',
            brandItemCode: 'EX14',
          },
          nwljddrqlbg2: {
            label: {
              en: 'Summit White',
              ar: 'القمة البيضاء',
            },
            image: 'images/2378/colors_new/ext/Summit White.png',
            usdz: 'blue',
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              KW: 0,
              default: 0,
            },
            index: 5,
            type: 'exterior',
            cardType: 'cart',
            cartImage: 'images/2378/colors_new/ext/Summit White.png',
            hasQuantity: false,
            autoIntelRPOCode: 'GAZ',
            brandItemCode: 'EX01',
          },
        },
      },
      features: {
        qlpdcncqd64b7: {
          label: {
            en: 'Front Facia',
            ar: 'الواجهة الأمامية',
          },
          image: 'images/2378/Z71_feat/Front_fascia.jpg',
          title: {
            en: 'Front Facia',
            ar: 'الواجهة الأمامية',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'exterior',
        },
        kh1xk6vtsachr: {
          label: {
            en: 'Capable Skid plate and Signature Red Tow hooks',
            ar: 'لوحة انزلاقية قادرة وخطافات سحب حمراء مميزة',
          },
          image: 'images/2378/Z71_feat/Skid_plate.jpg',
          title: {
            en: 'Capable Skid plate and Signature Red Tow hooks',
            ar: 'لوحة انزلاقية قادرة وخطافات سحب حمراء مميزة',
          },
          desc: {
            en: 'Protects your vehicle during the even toughest adventure',
            ar: 'يحمي سيارتك أثناء المغامرات الأكثر صعوبة.',
          },
          type: 'exterior',
        },
        '2uhwaenqtv8gj': {
          label: {
            en: 'All Terrain Tires',
            ar: 'إطارات لجميع التضاريس',
          },
          image: 'images/2378/Z71_feat/wheels.jpg',
          title: {
            en: 'All Terrain Tires',
            ar: 'إطارات لجميع التضاريس',
          },
          desc: {
            en: '18-inch Wheels, high gloss black painted machined face wheels with all terrain tyres',
            ar: 'عجلات مقاس 18 بوصة، عجلات مطلية باللون الأسود شديد اللمعان مع إطارات لجميع التضاريس',
          },
          type: 'exterior',
        },
        '1slkxzq7syxvp': {
          label: {
            en: 'ORVM',
            ar: 'ORVM',
          },
          image: 'images/2378/Z71_feat/ORVM.jpg',
          title: {
            en: 'ORVM',
            ar: 'ORVM',
          },
          desc: {
            en: 'Glossy Black Grille, Outside Rear View Mirror (OSRV)',
            ar: 'شبكة أمامية سوداء لامعة، مرآة الرؤية الخلفية الخارجية (OSRV)',
          },
          type: 'exterior',
        },
        kbnsv5f4ez323: {
          label: {
            en: 'Black Bowtie and Accents',
            ar: 'ربطة عنق سوداء وتفاصيل',
          },
          image: 'images/2378/Z71_feat/Black_Bowtie.jpg',
          title: {
            en: 'Black Bowtie and Accents',
            ar: 'ربطة عنق سوداء وتفاصيل',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'exterior',
        },
        okpcdbfyxu7lo: {
          label: {
            en: 'Z-71 Badging',
            ar: 'شارات Z-71',
          },
          image: 'images/2378/Z71_feat/Z71_Badging.jpg',
          title: {
            en: 'Z-71 Badging',
            ar: 'شارات Z-71',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'exterior',
        },
        okpcdmfyxu7lo: {
          label: {
            en: 'Roof Rails',
            ar: 'قضبان السقف',
          },
          image: 'images/2378/Z71_feat/Roof_Rails.jpg',
          title: {
            en: 'Roof Rails',
            ar: 'قضبان السقف',
          },
          desc: {
            en: 'Gloss Black Roof Rails',
            ar: 'قضبان سقف باللون الأسود اللامع',
          },
          type: 'exterior',
        },
        okpycdfyxu7lo: {
          label: {
            en: 'AutoSense Power Liftgate',
            ar: 'باب خلفي كهربائي AutoSense',
          },
          image: 'images/2378/Z71_feat/Autosense_Power_Liftgate Z71.jpg',
          title: {
            en: 'AutoSense Power Liftgate',
            ar: 'باب خلفي كهربائي AutoSense',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'exterior',
        },
        whq2pdteldd7b: {
          label: {
            en: 'Info Screen',
            ar: 'شاشة المعلومات',
          },
          image: 'images/2378/Z71_feat/info_screen.jpg',
          title: {
            en: 'Info Screen',
            ar: 'شاشة المعلومات',
          },
          desc: {
            en: '17.7 inch Diagonal color touchscreen featuring 6 speakers, google built one, powered by onstar, as well as Apple Car play/Android auto',
            ar: 'شاشة تعمل باللمس ملونة قطرية مقاس 17.7 بوصة تتميز بـ 6 مكبرات صوت، واحدة مدمجة من Google، مدعومة بنظام Onstar، بالإضافة إلى Apple Car play / Android Auto',
          },
          type: 'interior',
        },
        sulp9ougcljsd: {
          label: {
            en: 'Driver Information Center',
            ar: 'مركز معلومات السائق',
          },
          image: 'images/2378/Z71_feat/dic.jpg',
          title: {
            en: 'Driver Information Center',
            ar: 'مركز معلومات السائق',
          },
          desc: {
            en: '11 Inch Driver information center cluster',
            ar: 'لوحة معلومات السائق مقاس 11 بوصة',
          },
          type: 'interior',
        },
        '14ogjjvbzhg1q': {
          label: {
            en: 'Wireless Charger',
            ar: 'شاحن لاسلكي',
          },
          image: 'images/2378/Z71_feat/charger.jpg',
          title: {
            en: 'Wireless Charger',
            ar: 'شاحن لاسلكي',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        '1i87rhvwcyk2a': {
          label: {
            en: 'Selectable Drive Mode',
            ar: 'وضع القيادة القابل للتحديد',
          },
          image: 'images/2378/Z71_feat/drive_mode.jpg',
          title: {
            en: 'Selectable Drive Mode',
            ar: 'وضع القيادة القابل للتحديد',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        xje8uk6tk6c08: {
          label: {
            en: 'Adaptive Cruise Control',
            ar: 'نظام تثبيت السرعة التكيفي',
          },
          image: 'images/2378/Z71_feat/Adaptive_Cruise_Control.jpg',
          title: {
            en: 'Adaptive Cruise Control',
            ar: 'نظام تثبيت السرعة التكيفي',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        t8ynwcphoj7u: {
          label: {
            en: 'Luxury Chrome Fascia',
            ar: 'واجهة كروم فاخرة',
          },
          image: 'images/2378/LT_feat/Luxury_Chrome_Fascia.jpg',
          title: {
            en: 'Luxury Chrome Fascia',
            ar: 'واجهة كروم فاخرة',
          },
          desc: {
            en: 'A sleek design that improves the Cars Aerodynamics',
            ar: 'تصميم أنيق يحسن من الديناميكية الهوائية للسيارة',
          },
          type: 'exterior',
        },
        '067rg7evcxb1': {
          label: {
            en: '18" Wheels',
            ar: 'عجلات مقاس 18 بوصة',
          },
          image: 'images/2378/LT_feat/18Inch_Alloy.jpg',
          title: {
            en: '18" Wheels',
            ar: 'عجلات مقاس 18 بوصة',
          },
          desc: {
            en: 'The LT comes with grazen metallic machine-face aluminium wheels, perfect for families who love to adventure in the big city',
            ar: 'تتميز فئة LT بعجلات ألمنيوم معدنية مصقولة، وهي مثالية للعائلات التي تحب المغامرة في المدينة الكبيرة.',
          },
          type: 'exterior',
        },
        guhx4v57069b: {
          label: {
            en: 'LED Headlamps',
            ar: 'مصابيح أمامية LED',
          },
          image: 'images/2378/LT_feat/LED_Headlamp.jpg',
          title: {
            en: 'LED Headlamps',
            ar: 'مصابيح أمامية LED',
          },
          desc: {
            en: 'High-intensity LED reflector headlamps with LED curtain DRLs and White tracer animation',
            ar: 'مصابيح أمامية عاكسة LED عالية الكثافة مع أضواء نهارية ستائرية LED ورسوم متحركة بيضاء',
          },
          type: 'exterior',
        },
        xeer2id8g101: {
          label: {
            en: 'Trunk Space',
            ar: 'مساحة الجذع',
          },
          image: 'images/2378/LT_feat/Trunk_Space.png',
          title: {
            en: 'Trunk Space',
            ar: 'مساحة الجذع',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'exterior',
        },
        j0uvwd5nthk7: {
          label: {
            en: 'Info Screen',
            ar: 'شاشة المعلومات',
          },
          image: 'images/2378/LT_feat/info_screen.jpg',
          title: {
            en: 'Info Screen',
            ar: 'شاشة المعلومات',
          },
          desc: {
            en: '17.7 inch Diagonal color touchscreen featuring 6 speakers, google built one, powered by onstar, as well as Apple Car play/Android auto',
            ar: 'شاشة تعمل باللمس ملونة قطرية مقاس 17.7 بوصة تتميز بـ 6 مكبرات صوت، واحدة مدمجة من Google، مدعومة بنظام Onstar، بالإضافة إلى Apple Car play / Android Auto',
          },
          type: 'interior',
        },
        z3srxz0nqyp8: {
          label: {
            en: 'Driver Information Center',
            ar: 'مركز معلومات السائق',
          },
          image: 'images/2378/LT_feat/dic.jpg',
          title: {
            en: 'Driver Information Center',
            ar: 'مركز معلومات السائق',
          },
          desc: {
            en: '11 Inch Driver information center cluster',
            ar: 'لوحة معلومات السائق مقاس 11 بوصة',
          },
          type: 'interior',
        },
        c5iuh84l2wuy: {
          label: {
            en: 'Wireless Charger',
            ar: 'شاحن لاسلكي',
          },
          image: 'images/2378/LT_feat/charger.jpg',
          title: {
            en: 'Wireless Charger',
            ar: 'شاحن لاسلكي',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        x1i79a28r096: {
          label: {
            en: 'Heated Front Seats',
            ar: 'مقاعد أمامية مدفأة',
          },
          image: 'images/2378/LT_feat/Heated_Front_Seats.jpg',
          title: {
            en: 'Heated Front Seats',
            ar: 'مقاعد أمامية مدفأة',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        gan512rek2tm: {
          label: {
            en: '6 USB Ports - 2 in Each Row',
            ar: '6 منافذ USB - 2 في كل صف',
          },
          image: 'images/2378/LT_feat/USB_port.jpg',
          title: {
            en: '6 USB Ports - 2 in Each Row',
            ar: '6 منافذ USB - 2 في كل صف',
          },
          desc: {
            en: 'Easy access to keep all devices charged and ready for outdoor action',
            ar: 'سهولة الوصول للحفاظ على جميع الأجهزة مشحونة وجاهزة للعمل في الهواء الطلق',
          },
          type: 'interior',
        },
        qlpcncqd64b7: {
          label: {
            en: 'Luxury Chrome Fascia',
            ar: 'واجهة كروم فاخرة',
          },
          image: 'images/2378/LT_feat/Luxury_Chrome_Fascia.jpg',
          title: {
            en: 'Luxury Chrome Fascia',
            ar: 'واجهة كروم فاخرة',
          },
          desc: {
            en: 'A sleek design that improves the Cars Aerodynamics',
            ar: 'تصميم أنيق يحسن من الديناميكية الهوائية للسيارة',
          },
          type: 'exterior',
        },
        '2uhaenqtv8gj': {
          label: {
            en: '18" Wheels',
            ar: 'عجلات مقاس 18 بوصة',
          },
          image: 'images/2378/LT_feat/18Inch_Alloy.jpg',
          title: {
            en: '18" Wheels',
            ar: 'عجلات مقاس 18 بوصة',
          },
          desc: {
            en: 'The LT comes with grazen metallic machine-face aluminium wheels, perfect for families who love to adventure in the big city',
            ar: 'تتميز فئة LT بعجلات ألمنيوم معدنية مصقولة، وهي مثالية للعائلات التي تحب المغامرة في المدينة الكبيرة.',
          },
          type: 'exterior',
        },
        '1slkxz7syxvp': {
          label: {
            en: 'LED Headlamps',
            ar: 'مصابيح أمامية LED',
          },
          image: 'images/2378/LT_feat/LED_Headlamp.jpg',
          title: {
            en: 'LED Headlamps',
            ar: 'مصابيح أمامية LED',
          },
          desc: {
            en: 'High-intensity LED reflector headlamps with LED curtain DRLs and White tracer animation',
            ar: 'مصابيح أمامية عاكسة LED عالية الكثافة مع أضواء نهارية ستائرية LED ورسوم متحركة بيضاء',
          },
          type: 'exterior',
        },
        wh2pdteldd7b: {
          label: {
            en: 'Info Screen',
            ar: 'شاشة المعلومات',
          },
          image: 'images/2378/LT_feat/info_screen.jpg',
          title: {
            en: 'Info Screen',
            ar: 'شاشة المعلومات',
          },
          desc: {
            en: '17.7 inch Diagonal color touchscreen featuring 6 speakers, google built one, powered by onstar, as well as Apple Car play/Android auto',
            ar: 'شاشة تعمل باللمس ملونة قطرية مقاس 17.7 بوصة تتميز بـ 6 مكبرات صوت، واحدة مدمجة من Google، مدعومة بنظام Onstar، بالإضافة إلى Apple Car play / Android Auto',
          },
          type: 'interior',
        },
        sulp9ugcljsd: {
          label: {
            en: 'Driver Information Center',
            ar: 'مركز معلومات السائق',
          },
          image: 'images/2378/LT_feat/dic.jpg',
          title: {
            en: 'Driver Information Center',
            ar: 'مركز معلومات السائق',
          },
          desc: {
            en: '11 Inch Driver information center cluster',
            ar: 'لوحة معلومات السائق مقاس 11 بوصة',
          },
          type: 'interior',
        },
        '14ojjvbzhg1q': {
          label: {
            en: 'Wireless Charger',
            ar: 'شاحن لاسلكي',
          },
          image: 'images/2378/LT_feat/charger.jpg',
          title: {
            en: 'Wireless Charger',
            ar: 'شاحن لاسلكي',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        '1i87rvwcyk2a': {
          label: {
            en: 'Heated Front Seats',
            ar: 'مقاعد أمامية مدفأة',
          },
          image: 'images/2378/LT_feat/Heated_Front_Seats.jpg',
          title: {
            en: 'Heated Front Seats',
            ar: 'مقاعد أمامية مدفأة',
          },
          desc: {
            en: '',
            ar: '',
          },
          type: 'interior',
        },
        xje8k6tk6c08: {
          label: {
            en: '6 USB Ports - 2 in Each Row',
            ar: '6 منافذ USB - 2 في كل صف',
          },
          image: 'images/2378/LT_feat/USB_port.jpg',
          title: {
            en: '6 USB Ports - 2 in Each Row',
            ar: '6 منافذ USB - 2 في كل صف',
          },
          desc: {
            en: 'Easy access to keep all devices charged and ready for outdoor action',
            ar: 'سهولة الوصول للحفاظ على جميع الأجهزة مشحونة وجاهزة للعمل في الهواء الطلق',
          },
          type: 'interior',
        },
      },
      accessories: {
        w9hpezuxt0zw: {
          label: {
            en: 'Variant_Parts_Z71_AWD',
            ar: 'أجزاء متغيرة Z71 AWD',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        '69tpimc80pm8d': {
          label: {
            en: 'Roof',
            ar: 'سقف',
          },
          image: '',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        '5cq7w508taix': {
          label: {
            en: 'Dual Glass Panaromic Sunroof',
            ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
          },
          image: 'images/2378/Z71_Sunroof.jpg',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 4940,
            UAE: 4848,
            OMR: 514,
            BHD: 501,
            QAR: 4795,
            JOD: 935,
            KW: 408,
            LBP: 1317,
            IQD: 1317,
            default: 4848,
          },
          cardType: 'cart',
          autoIntelRPOCode: 'CAJ',
          brandItemCode: 'AC35',
        },
        u20mu3d5j71vd: {
          label: {
            en: '18 inch High Gloss Black Machined face',
            ar: '18 بوصة وجه مصنوع آليًا أسود لامع عالي',
          },
          image: '',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        ph2ilwyfnyoz: {
          label: {
            en: 'Variant_Parts_LT_AWD',
            ar: 'أجزاء متغيرة LT AWD',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        '58463v6cha9h': {
          label: {
            en: 'WO_Sunroof',
            ar: 'بدون فتحة سقف',
          },
          image: '',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        bz1v4t37607s: {
          label: {
            en: 'Dual Glass Panaromic Sunroof',
            ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
          },
          image: 'images/2378/LT_Sunroof.jpg',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 4940,
            UAE: 4848,
            OMR: 514,
            BHD: 501,
            QAR: 4795,
            JOD: 935,
            KW: 408,
            LBP: 1317,
            IQD: 1317,
            default: 4848,
          },
          cardType: 'cart',
          autoIntelRPOCode: 'CAJ',
          brandItemCode: 'AC35',
        },
        u1947q9mlw5i: {
          label: {
            en: 'WO_Midnight_Edition',
            ar: 'بدون إصدار منتصف الليل',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        dnc6qvmfvihz: {
          label: {
            en: 'W_Midnight_Edition',
            ar: 'مع إصدار منتصف الليل',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        sisoevvyzbkx: {
          label: {
            en: '18 Inch_Grazen_Metallic_aluminum',
            ar: '18 بوصة ألومنيوم معدني جرازين',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        wegeh5s0vwal: {
          label: {
            en: '20 inch High Gloss Black painted Aluminium',
            ar: '20 بوصة ألومنيوم مطلي أسود لامع عالي',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        arzp4zbywxqd: {
          label: {
            en: '20 inch_Carbon_Flash_Metalic',
            ar: '20 بوصة كربون فلاش معدني',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        myq5eupjxhja: {
          label: {
            en: 'Bench Seats default',
            ar: 'مقاعد البدلاء افتراضي',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        lcp3flb8g8m6: {
          label: {
            en: 'Bench Seats',
            ar: 'مقاعد البدلاء',
          },
          image: 'images/2378/LT_BenchSeats_Evotex.jpg',
          category: {
            en: 'Seats',
            ar: 'مقاعد',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
          autoIntelRPOCode: 'AR9',
          brandItemCode: 'AC36',
        },
        z9ajh37fas0j: {
          label: {
            en: 'Variant_Parts_LT_FWD',
            ar: 'أجزاء متغيرة LT FWD',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        r4764rbf9ulm: {
          label: {
            en: 'WO_Sunroof',
            ar: 'بدون فتحة سقف',
          },
          image: '',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            KW: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        a32j9gyvb1sn: {
          label: {
            en: 'Dual Glass Panaromic Sunroof',
            ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
          },
          image: 'images/2378/LT_Sunroof.jpg',
          category: {
            en: 'Roof',
            ar: 'سَطح',
          },
          price: {
            KSA: 4940,
            UAE: 4848,
            OMR: 514,
            BHD: 501,
            QAR: 4795,
            JOD: 935,
            KW: 408,
            LBP: 1317,
            IQD: 1317,
            default: 4848,
          },
          cardType: 'cart',
          autoIntelRPOCode: 'CAJ',
          brandItemCode: 'AC35',
        },
        i4hkqruarfkl: {
          label: {
            en: 'WO_Midnight_Edition',
            ar: 'بدون إصدار منتصف الليل',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        ox0nj2j5ceyj: {
          label: {
            en: 'W_Midnight_Edition',
            ar: 'مع إصدار منتصف الليل',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        '3nc1olw2alfk': {
          label: {
            en: '18 Inch_Grazen_Metallic_aluminum',
            ar: '18 بوصة ألومنيوم معدني جرازين',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        '3nc1olw2alfa': {
          label: {
            en: '20 inch_High_Gloss_Black_painted_Aluminium',
            ar: '20 بوصة ألومنيوم مطلي أسود لامع عالي',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        anc1alw2alfa: {
          label: {
            en: '20 inch_Carbon_Flash_Metalic',
            ar: '20 بوصة كربون فلاش معدني',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        xnc1alw2alfa: {
          label: {
            en: 'Bench Seats default',
            ar: 'مقاعد البدلاء افتراضي',
          },
          image: '',
          category: {
            en: 'Accessories',
            ar: 'مُكَمِّلات',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
        },
        mnc1alw2alfa: {
          label: {
            en: 'Bench Seats',
            ar: 'مقاعد البدلاء',
          },
          image: 'images/2378/LT_BenchSeats_Evotex.jpg',
          category: {
            en: 'Seats',
            ar: 'مقاعد',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
          autoIntelRPOCode: 'AR9',
          brandItemCode: 'AC36',
        },
      },
      packages: {
        'x7vtyrufcgr0-lt': {
          label: {
            en: 'Midnight/Sports Edition Package',
            ar: 'حزمة إصدار منتصف الليل/الرياضة',
          },
          image: 'images/2378/LT_Midnight Edition.jpg',
          category: {
            en: 'Packages',
            ar: 'الحزم',
          },
          price: {
            KSA: 3383,
            UAE: 3320,
            OMR: 352,
            BHD: 343,
            QAR: 3284,
            JOD: 641,
            KW: 280,
            LBP: 902,
            IQD: 902,
            default: 3320,
          },
          cardType: 'cart',
          packageDescription: {
            en: 'The Midnight/Sports Edition Package comes with Black grille with unique finish, Chevrolet Black bowties, Black nameplate, Black high gloss door upper and black low gloss belt moldings and 20" High-gloss black painted aluminum wheels.',
            ar: 'تتضمن حزمة Midnight/Sports Edition شبكًا أسودًا بلمسة نهائية فريدة، وشعار Chevrolet Black، ولوحة اسم سوداء، وغطاء علوي أسود شديد اللمعان للباب، وقوالب حزام سوداء منخفضة اللمعان، وعجلات من الألومنيوم المطلية باللون الأسود شديد اللمعان مقاس 20 بوصة.',
          },
          accessoryContent: [
            {
              accessoryDescription: {
                en: 'Black grille with unique finish',
                ar: 'شبك أسود بلمسة نهائية فريدة',
              },
              accessoryTitle: {
                en: 'Black grille with unique finish',
                ar: 'شبك أسود بلمسة نهائية فريدة',
              },
              image: 'images/2378/MID_LT_Black_Grille.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: 'Chevrolet Black bowties',
                ar: 'شيفروليه بلاك بووتيس',
              },
              accessoryTitle: {
                en: 'Chevrolet Black bowties',
                ar: 'شيفروليه بلاك بووتيس',
              },
              image: 'images/2378/MID_LT_Black_Chevrolet_Bowtie.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: 'Black nameplate',
                ar: 'لوحة اسم سوداء',
              },
              accessoryTitle: {
                en: 'Black nameplate',
                ar: 'لوحة اسم سوداء',
              },
              image: 'images/2378/MID_LT_Black_Nameplate_AWD.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: 'Black high gloss door upper and black low gloss belt moldings',
                ar: 'الجزء العلوي للباب شديد اللمعان باللون الأسود وقوالب الحزام منخفضة اللمعان باللون الأسود',
              },
              accessoryTitle: {
                en: 'Black high gloss door upper and black low gloss belt moldings',
                ar: 'الجزء العلوي للباب شديد اللمعان باللون الأسود وقوالب الحزام منخفضة اللمعان باللون الأسود',
              },
              image: 'images/2378/MID_LT_Black_Moldings.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: '20" High-gloss black painted aluminum wheels',
                ar: 'عجلات من الألومنيوم المطلي باللون الأسود شديد اللمعان مقاس 20 بوصة',
              },
              accessoryTitle: {
                en: '20" High-gloss black painted aluminum wheels',
                ar: 'عجلات من الألومنيوم المطلي باللون الأسود شديد اللمعان مقاس 20 بوصة',
              },
              image: 'images/2378/MID_LT_Black_Alloy.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
          ],
          autoIntelRPOCode: 'WJU',
          brandItemCode: 'PA11',
        },
        'x7vtyrurfcgr0-lt': {
          label: {
            en: 'Sun and Wheel Package',
            ar: 'باقة الشمس والعجلات',
          },
          image: 'images/2378/LT_Sun_and_Wheel_Package.jpg',
          category: {
            en: 'Packages',
            ar: 'الحزم',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
          packageDescription: {
            en: 'The Sun and Wheel Package comes with Dual Glass Panoramic Sunroof and 20" Carbon Flash Metallic wheels.',
            ar: 'تشتمل باقة الشمس والعجلات على سقف بانورامي مزدوج الزجاج وعجلات Carbon Flash Metallic مقاس 20 بوصة.',
          },
          accessoryContent: [
            {
              accessoryDescription: {
                en: 'Dual Glass Panoramic Sunroof',
                ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
              },
              accessoryTitle: {
                en: 'Dual Glass Panoramic Sunroof',
                ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
              },
              image: 'images/2378/SUN_LT_Sunroof.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: '20" Carbon Flash Metallic wheels',
                ar: 'عجلات كربون فلاش ميتاليك مقاس 20 بوصة',
              },
              accessoryTitle: {
                en: '20" Carbon Flash Metallic wheels',
                ar: 'عجلات كربون فلاش ميتاليك مقاس 20 بوصة',
              },
              image: 'images/2378/SUN_LT_Carbon_Flash_Alloy.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
          ],
          autoIntelRPOCode: 'BAQ',
          brandItemCode: 'PA12',
        },
        'x7vtyruofcgr0-lt-d5tbgkkfd7k97': {
          label: {
            en: 'Midnight/Sports Edition Package',
            ar: 'حزمة إصدار منتصف الليل/الرياضة',
          },
          image: 'images/2378/LT_Midnight Edition.jpg',
          category: {
            en: 'Packages',
            ar: 'الحزم',
          },
          price: {
            KSA: 3383,
            UAE: 3320,
            OMR: 352,
            BHD: 343,
            QAR: 3284,
            JOD: 641,
            KW: 280,
            LBP: 902,
            IQD: 902,
            default: 3320,
          },
          cardType: 'cart',
          packageDescription: {
            en: 'The Midnight/Sports Edition Package comes with Black grille with unique finish, Chevrolet Black bowties, Black nameplate, Black high gloss door upper and black low gloss belt moldings and 20" High-gloss black painted aluminum wheels.',
            ar: 'تتضمن حزمة Midnight/Sports Edition شبكًا أسودًا بلمسة نهائية فريدة، وشعار Chevrolet Black، ولوحة اسم سوداء، وغطاء علوي أسود شديد اللمعان للباب، وقوالب حزام سوداء منخفضة اللمعان، وعجلات من الألومنيوم المطلية باللون الأسود شديد اللمعان مقاس 20 بوصة.',
          },
          accessoryContent: [
            {
              accessoryDescription: {
                en: 'Black grille with unique finish',
                ar: 'شبك أسود بلمسة نهائية فريدة',
              },
              accessoryTitle: {
                en: 'Black grille with unique finish',
                ar: 'شبك أسود بلمسة نهائية فريدة',
              },
              image: 'images/2378/MID_LT_Black_Grille.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: 'Chevrolet Black bowties',
                ar: 'شيفروليه بلاك بووتيس',
              },
              accessoryTitle: {
                en: 'Chevrolet Black bowties',
                ar: 'شيفروليه بلاك بووتيس',
              },
              image: 'images/2378/MID_LT_Black_Chevrolet_Bowtie.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: 'Black nameplate',
                ar: 'لوحة اسم سوداء',
              },
              accessoryTitle: {
                en: 'Black nameplate',
                ar: 'لوحة اسم سوداء',
              },
              image: 'images/2378/MID_LT_Black_Nameplate_FWD.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: 'Black high gloss door upper and black low gloss belt moldings',
                ar: 'الجزء العلوي للباب شديد اللمعان باللون الأسود وقوالب الحزام منخفضة اللمعان باللون الأسود',
              },
              accessoryTitle: {
                en: 'Black high gloss door upper and black low gloss belt moldings',
                ar: 'الجزء العلوي للباب شديد اللمعان باللون الأسود وقوالب الحزام منخفضة اللمعان باللون الأسود',
              },
              image: 'images/2378/MID_LT_Black_Moldings.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: '20" High-gloss black painted aluminum wheels',
                ar: 'عجلات من الألومنيوم المطلي باللون الأسود شديد اللمعان مقاس 20 بوصة',
              },
              accessoryTitle: {
                en: '20" High-gloss black painted aluminum wheels',
                ar: 'عجلات من الألومنيوم المطلي باللون الأسود شديد اللمعان مقاس 20 بوصة',
              },
              image: 'images/2378/MID_LT_Black_Alloy.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
          ],
          autoIntelRPOCode: 'WJU',
          brandItemCode: 'PA11',
        },
        'x7vtyrufcgr0t-lt-d5tbgkkfd7k97': {
          label: {
            en: 'Sun and Wheel Package',
            ar: 'باقة الشمس والعجلات',
          },
          image: 'images/2378/LT_Sun_and_Wheel_Package.jpg',
          category: {
            en: 'Packages',
            ar: 'الحزم',
          },
          price: {
            KSA: 0,
            UAE: 0,
            OMR: 0,
            BHD: 0,
            QAR: 0,
            JOD: 0,
            default: 0,
          },
          cardType: 'cart',
          packageDescription: {
            en: 'The Sun and Wheel Package comes with Dual Glass Panoramic Sunroof and 20" Carbon Flash Metallic wheels.',
            ar: 'تشتمل باقة الشمس والعجلات على سقف بانورامي مزدوج الزجاج وعجلات Carbon Flash Metallic مقاس 20 بوصة.',
          },
          accessoryContent: [
            {
              accessoryDescription: {
                en: 'Dual Glass Panoramic Sunroof',
                ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
              },
              accessoryTitle: {
                en: 'Dual Glass Panoramic Sunroof',
                ar: 'فتحة سقف بانورامية مزدوجة الزجاج',
              },
              image: 'images/2378/SUN_LT_Sunroof.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
            {
              accessoryDescription: {
                en: '20" Carbon Flash Metallic wheels',
                ar: 'عجلات كربون فلاش ميتاليك مقاس 20 بوصة',
              },
              accessoryTitle: {
                en: '20" Carbon Flash Metallic wheels',
                ar: 'عجلات كربون فلاش ميتاليك مقاس 20 بوصة',
              },
              image: 'images/2378/SUN_LT_Carbon_Flash_Alloy.jpg',
              price: {
                KSA: 0,
                UAE: 0,
                OMR: 0,
                BHD: 0,
                QAR: 0,
                JOD: 0,
                default: 0,
              },
            },
          ],
          autoIntelRPOCode: 'BAQ',
          brandItemCode: 'PA12',
        },
      },
      interactions: {
        '82lc5jd2ekej': {
          label: {
            en: 'Doors',
            ar: 'الأبواب',
          },
          type: 'interaction',
        },
        dfgiszto8mb3: {
          label: {
            en: 'Boot',
            ar: 'صندوق المركبة',
          },
          type: 'interaction',
        },
        auuqx6b61pgx: {
          label: {
            en: 'Sunroof',
            ar: 'فتحة السقف',
          },
          type: 'interaction',
        },
        frif2u36is65: {
          label: {
            en: 'Headlight',
            ar: 'ضوء السقف',
          },
          type: 'interaction',
        },
        bpgyvbbuz3x4: {
          label: {
            en: 'DRL',
            ar: 'DRL',
          },
          type: 'interaction',
        },
        wjs0s4nuo7zq: {
          label: {
            en: 'Taillight',
            ar: 'الضوء الخلفي',
          },
          type: 'interaction',
        },
      },
      hotspots: {
        exteriorCamera: {
          title: {
            en: 'Exterior',
            ar: 'الخارج',
          },
        },
        interiorCamera: {
          title: {
            en: 'First Row Seat',
            ar: 'مقعد الصف الأول',
          },
        },
        interiorCamera_1: {
          title: {
            en: 'Second Row Seat',
            ar: 'مقعد الصف الثاني',
          },
        },
        interiorCamera_2: {
          title: {
            en: 'Third Row Seat',
            ar: 'مقعد الصف الثالث',
          },
        },
      },
      name: {
        en: 'Chevrolet Traverse',
        ar: 'Chevrolet Traverse',
      },
      specifications: {
        heading: {
          en: 'Chevrolet Traverse',
          ar: 'Chevrolet Traverse',
        },
        trim: {
          en: 'Z71',
          ar: 'Z71',
        },
        price: {
          en: 'Starting from 173400 MSRP',
          ar: 'ابتداء من173400 MSRP',
        },
        model: 'Chevrolet Traverse',
        seatingCapacity: 'Upto 7(Z71)/ Upto 8(LT)',
        dimensions: {
          length: '5200mm(Z71)/5194mm(LT)',
          width: '',
          height: '',
          wheelbase: '3072 mm',
          groundClearance: '',
        },
        performance: [
          {
            value: '328',
            unit: 'HP',
            label: {
              en: 'Horsepower',
              ar: 'حصان',
            },
          },
          {
            value: '442',
            unit: 'NM',
            label: {
              en: 'Torque',
              ar: 'عزم الدوران',
            },
          },
          {
            value: '2.5L',
            unit: '',
            label: {
              en: 'Turbo Engine',
              ar: 'Turbo محرك',
            },
          },
        ],
        summary: [
          {
            title: {
              en: 'Model',
              ar: 'نموذج',
            },
            subtitle: {
              en: 'Chevrolet Traverse',
              ar: 'Chevrolet Traverse',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Exterior Colors',
              ar: 'الألوان الخارجية',
            },
            subtitle: {
              en: 'Polar White Tricoat, Summit White (LT Trim only), Mosaic Black Metallic, Radiant Red Tintcoat, Sterling Gray Metallic, Lakeshore Blue Metallic, Sandstone Gray (Z71 Trim only)',
              ar: 'أبيض قطبي ثلاثي الطبقات، أبيض قمة (طراز LT فقط)، أسود موزاييك معدني، أحمر لامع تينكوت، رمادي ستيرلينج معدني، أزرق ليكشور معدني، رمادي ساندستون (طراز Z71 فقط)',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Interior',
              ar: 'الداخلية',
            },
            subtitle: {
              en: 'Z71 Trim: Jet Black with Torch Red Accents Evotex, and LT Trim: Jet Black Premium Cloth, Jet Black / Gideon Premium Cloth, Jet Black Evotex',
              ar: 'Z71 Trim: Jet Black مع لمسات من اللون الأحمر الفاتح Evotex، وLT Trim: Jet Black Premium Cloth، Jet Black / Gideon Premium Cloth',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Wheelbase',
              ar: 'قاعدة العجلات',
            },
            subtitle: {
              en: '3072 mm',
              ar: '3072 mm',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Length',
              ar: 'Length',
            },
            subtitle: {
              en: '5200mm(Z71)/5194mm(LT)',
              ar: '5200mm(Z71)/5194mm(LT)',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Cargo Space',
              ar: 'Cargo Space',
            },
            subtitle: {
              en: 'Behind 1st row seat- 2764 litres, Behind 2nd row seat- 1602.9 litres, Behind 3rd row seat- 648.5 liters',
              ar: 'خلف مقعد الصف الأول - 2764 لترًا، خلف مقعد الصف الثاني - 1602.9 لترًا، خلف مقعد الصف الثالث - 648.5 لترًا',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Transmission',
              ar: 'الانتقال',
            },
            subtitle: {
              en: '8-speed Automatic',
              ar: 'ناقل حركة أوتوماتيكي بـ 8 سرعات',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'OnStar Connect Plan',
              ar: 'خطة الاتصال والحمايةOnStar',
            },
            subtitle: {
              en: '3 Years',
              ar: '3 سنوات',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Seating Capacity',
              ar: 'سعة الجلوس',
            },
            subtitle: {
              en: 'Upto 7(Z71)/ Upto 8(LT)',
              ar: 'حتى 7 (Z71)/ 8 حتى (LT)',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
          {
            title: {
              en: 'Infotainment Screen',
              ar: 'شاشة المعلومات والترفيه',
            },
            subtitle: {
              en: '17.7" diagonal advanced color high-contrast LCD display with Google built-in compatibility',
              ar: 'شاشة LCD متطورة عالية التباين ملونة مقاس 17.7 بوصة مع توافق مدمج مع Google',
            },
            price: {
              KSA: 0,
              UAE: 0,
              OMR: 0,
              BHD: 0,
              QAR: 0,
              JOD: 0,
              default: 0,
            },
          },
        ],
      },
    },
  },
  plugins: {
    deferredAssetLoading: true,
  },
  staticTranslations: {
    specDetails: {
      model: {
        en: 'Model',
        ar: 'نموذج',
      },
      exteriorColours: {
        en: 'Exterior',
        ar: 'الخارجة',
      },
      interiorAmbience: {
        en: 'Interior',
        ar: 'الداخلية',
      },
      seatingCapacity: {
        en: 'Seating Capacity',
        ar: 'سعة المقاعد',
      },
      length: {
        en: 'Length',
        ar: 'الطول',
      },
      width: {
        en: 'Width',
        ar: 'العرض',
      },
      height: {
        en: 'Height',
        ar: 'الارتفاع',
      },
      wheelbase: {
        en: 'Wheelbase',
        ar: 'قاعدة العجلات',
      },
      groundClearance: {
        en: 'Ground Clearance',
        ar: 'الخلوص الأرضي',
      },
      share: {
        en: 'Share',
        ar: 'يشارك',
      },
    },
    variantSelection: {
      title: {
        en: 'Model',
        ar: 'نموذج',
      },
      select: {
        en: 'Select',
        ar: 'تحديد',
      },
      cancel: {
        en: 'Cancel',
        ar: 'إلغاء',
      },
      selectBodyStyle: { en: 'Select Body Style', ar: 'اختر نمط الهيكل' },
      availableTrims: { en: 'Select Trim', ar: 'اختر الفئة' },
      driveType: { en: 'Drive Type', ar: 'نوع القيادة' },
      model: { en: 'Model', ar: 'الموديل' },
    },
    loadingScreen: {
      default: {
        en: 'Preparing the canvas for your dream car. Just a few more seconds to go!',
        ar: 'لحظات ونبدأ رحلة تصميم سيارة أحلامك... باقي ثوانٍ قليلة!',
      },
      enterConfigurator: {
        en: 'Build Your Ride',
        ar: 'ابنِ سيارتك',
      },
      loading: { en: 'Loading', ar: 'جارٍ التحميل' },
      variantLoading: { en: 'Trim is loading', ar: 'نموذج جارٍ التحميل' },
      viewLoading: {
        en: 'Applying final touches',
        ar: 'تطبيق اللمسات النهائية',
      },
      disclaimer: {
        en: 'Disclaimer',
        ar: 'تنصل',
      },
      termsConditions: {
        en: 'Terms & Conditions',
        ar: 'الشروط والأحكام',
      },
      viewSpecDetails: {
        en: 'View Spec Details',
        ar: 'ععرض تفاصيل المواصفات',
      },
      disclaimerContent: {
        en: 'Prices are subject to change without prior notice and may vary based on location, availability, or other factors.',
        ar: 'الأسعار عرضة للتغيير دون إشعار مسبق وقد تختلف بناءً على الموقع والتوافر وعوامل أخرى.',
      },
      termsModal: {
        title: {
          en: 'Configurator Use Terms and Conditions',
          ar: 'شروط وأحكام استخدام المُكوِّن',
        },
        lead: {
          en: 'By using this vehicle configurator and submitting your build, you acknowledge and agree to the following:',
          ar: 'من خلال استخدام مُكوِّن تكوين السيارة هذا وإرسال تصميمك، فإنك تقر وتوافق على ما يلي:',
        },
        sections: {
          item1: {
            title: {
              en: 'Non-Binding Submission',
              ar: 'تقديم غير ملزم',
            },
            content: {
              en: 'Submitting your vehicle configuration does not constitute a formal vehicle order or purchase agreement. No payment or deposit is collected at this stage.',
              ar: 'إرسال مواصفات سيارتك لا يُعد طلبًا رسميًا للسيارة أو اتفاقية شراء. لا يتم تحصيل أي مبلغ أو دفعة مقدمة في هذه المرحلة.',
            },
          },
          item2: {
            title: {
              en: 'Preliminary Estimate',
              ar: 'تقدير أولي',
            },
            content: {
              en: 'All pricing displayed is Manufacturer’s Suggested Retail Price (MSRP)and is provided for informational purposes only. Final pricing, taxes, fees, and applicable offers will be confirmed by the authorized dealer.',
              ar: 'جميع الأسعار المعروضة هي سعر التجزئة المقترح من الشركة المصنعة، وهي لأغراض إعلامية فقط. سيتم تأكيد الأسعار النهائية والضرائب والرسوم والعروض المطبقة من قبل الوكيل المعتمد.',
            },
          },
          item3: {
            title: {
              en: 'Dealer Follow-Up',
              ar: 'متابعة التاجر',
            },
            content: {
              en: 'Your submitted configuration will be shared with a participating dealer, who will contact you to discuss your preferences, availability, and next steps.',
              ar: 'سيتم مشاركة التكوين الذي أرسلته مع أحد التجار المشاركين، والذي سيتصل بك لمناقشة تفضيلاتك وتوافرك والخطوات التالية.',
            },
          },
          item4: {
            title: {
              en: 'Availability and Fulfillment',
              ar: 'التوفر والوفاء',
            },
            content: {
              en: 'We will make every reasonable effort to fulfill your preferences; however, final vehicle and accessories selection is subject to dealer inventory and production availability. Configurations may be limited to in-stock or incoming vehicles.',
              ar: 'سنبذل قصارى جهدنا لتلبية تفضيلاتكم، إلا أن الاختيار النهائي للمركبات والملحقات يخضع لمخزون الوكيل وتوافر الإنتاج. قد تقتصر التكوينات على المركبات المتوفرة في المخزون أو الواردة.',
            },
          },
          item5: {
            title: {
              en: 'No Obligation',
              ar: 'لا يوجد التزام',
            },
            content: {
              en: 'You are under no obligation to purchase the configured vehicle, and submitting your configuration does not create a contractual relationship between you and the manufacturer or dealer.',
              ar: 'لا يوجد أي التزام عليك بشراء السيارة المخصصة، كما أن إرسال التكوين الخاص بك لا يؤدي إلى إنشاء علاقة تعاقدية بينك وبين الشركة المصنعة أو التاجر.',
            },
          },
          item6: {
            title: {
              en: 'Use of Personal Information and Consent',
              ar: 'استخدام المعلومات الشخصية والموافقة',
            },
            content: {
              en: 'By submitting your configuration, you consent to the collection, use, and sharing of your personal information with authorized dealers to facilitate your request, in accordance with our [Privacy Statement].',
              ar: 'من خلال إرسال التكوين الخاص بك، فإنك توافق على جمع معلوماتك الشخصية واستخدامها ومشاركتها مع التجار المعتمدين لتسهيل طلبك، وفقًا لـ [بيان الخصوصية] الخاص بنا.',
            },
          },
          item7: {
            title: {
              en: 'System Limitations',
              ar: 'قيود النظام',
            },
            content: {
              en: 'While we aim to provide accurate and current information, the configurator may not reflect all available features or up-to-date pricing. Errors or omissions may occur.',
              ar: 'مع أننا نهدف إلى توفير معلومات دقيقة وحديثة، إلا أن مُكوِّن الإعدادات قد لا يعكس جميع الميزات المتاحة أو الأسعار المُحدَّثة. قد تحدث أخطاء أو سهو.',
            },
          },
        },
      },
    },
    common: {
      exit: {
        en: 'Exit',
        ar: 'خروج',
      },
      close: {
        en: 'Close',
        ar: 'إغلاق',
      },
      cancel: {
        en: 'Cancel',
        ar: 'إلغاء',
      },
      back: {
        en: 'Back',
        ar: 'خلف',
      },
      next: {
        en: 'Next',
        ar: 'التالي',
      },
      done: {
        en: 'Done',
        ar: 'تم',
      },
      exterior: {
        en: 'Exterior',
        ar: 'الخارجة',
      },
      interior: {
        en: 'Interior',
        ar: 'الداخلية',
      },
      enterFullscreen: {
        en: 'Enter Fullscreen',
        ar: 'ملء الشاشة',
      },
      exitFullscreen: {
        en: 'Exit Fullscreen',
        ar: 'إلغاء ملء الشاشة',
      },
      selectTrim: {
        en: 'Select Trim',
        ar: 'اختر الفئة',
      },
      viewConfiguration: {
        en: 'View Configuration',
        ar: 'عرض التكوين',
      },
      togglePanelTooltip: {
        en: 'Select Trim and Configuration',
        ar: 'اختر الفئة والتكوين',
      },
      nextStepTooltip: {
        en: 'Click to proceed to the next step',
        ar: 'انقر للانتقال إلى الخطوة التالية',
      },
      heading: {
        en: 'Standard Features',
        ar: 'المميزات  القياسية',
      },
      description: {
        en: 'Chevrolet Arabia',
        ar: 'شيفروليه العربية',
      },
      goBack: { en: 'Go Back', ar: 'العودة' },
      freeRoamView: { en: 'Free Roam View', ar: 'عرض التجوال الحر' },
      featureView: { en: 'Featured View', ar: 'عرض مميز' },
      configurator: { en: 'Configurator', ar: 'المُكوِّن' },
      buildYourRide: { en: 'Build Your Ride', ar: 'ابنِ سيارتك' },
      options: { en: 'Options', ar: 'الخيارات' },
      summary: { en: 'Summary', ar: 'الملخص' },
      saveYourBuild: { en: 'Save Your Build', ar: 'احفظ تكوينك' },
      startingPrice: { en: 'Starting Price', ar: 'السعر الابتدائي' },
      msrp: { en: 'MSRP', ar: 'سعر التجزئة المقترح' },
      proceed: { en: 'Proceed', ar: 'متابعة' },
    },
    tabs: {
      config: { en: 'Config', ar: 'الإعداد' },
      model: { en: 'Model', ar: 'الموديل' },
      exterior: { en: 'Exterior', ar: 'الخارجي' },
      interior: { en: 'Interior', ar: 'الداخلي' },
      options: { en: 'Options', ar: 'الخيارات' },
      summary: { en: 'Summary', ar: 'الملخص' },
    },
    cart: {
      title: {
        en: 'Your Order',
        ar: 'طلبك',
      },
      disclaimer: {
        en: 'Accessory prices and availability will be confirmed at the showroom.',
        ar: 'سيتم تأكيد أسعار الملحقات وتوافرها في صالة العرض.',
      },
      exteriorLabel: {
        en: 'Exterior:',
        ar: ':خارجي',
      },
      interiorLabel: {
        en: 'Interior:',
        ar: ':داخلي',
      },
      addedAccessories: {
        en: 'Added Accessories',
        ar: 'الإكسسوارات المضافة',
      },
      priceEstimate: {
        en: 'Price Estimate',
        ar: 'السعر التقديري',
      },
      priceBreakdown: {
        en: 'Price Breakdown',
        ar: 'تفاصيل السعر',
      },
      reserveNow: {
        en: 'Proceed',
        ar: 'متابعة',
      },
      removeAccessory: {
        en: 'Remove accessory',
        ar: 'إزالة الإكسسوار',
      },
      removeItem: { en: 'Remove', ar: 'إزالة' },
      packageCategory: { en: 'Package', ar: 'حزمة' },
    },
    saveDialog: {
      optionsTitle: {
        en: 'How would you like to proceed?',
        ar: 'كيف تريد المتابعة؟',
      },
      optionWhatsapp: { en: 'Save to WhatsApp', ar: 'حفظ على واتساب' },
      optionEmail: { en: 'Save to Email', ar: 'حفظ على البريد الإلكتروني' },
      optionTestDrive: {
        en: 'Book a Test Drive',
        ar: 'احجز اختبار قيادة',
      },
      optionCallback: {
        en: 'Request a call Back',
        ar: 'طلب معاودة الاتصال',
      },
      labelFirstName: {
        en: 'First Name*',
        ar: 'الاسم الأول',
      },
      labelLastName: {
        en: 'Last Name*',
        ar: 'اسم العائلة',
      },
      labelEmail: {
        en: 'Email*',
        ar: 'البريد الالكتروني',
      },
      labelMobileNumber: {
        en: 'Mobile Number*',
        ar: 'رقم الجوال',
      },
      labelPrefix: {
        en: 'Prefix',
        ar: 'البادئة',
      },
      labelModel: {
        en: 'Model',
        ar: 'نموذج',
      },
      labelDealership: {
        en: 'Preferred Dealership*',
        ar: 'الوكيل المفضّل',
      },
      labelComments: {
        en: 'Comments',
        ar: 'تعليقات',
      },
      labelTestDriveDate: {
        en: 'Preferred date*',
        ar: 'التاريخ المفضل*',
      },
      labelTestDriveTime: {
        en: 'Preferred time*',
        ar: 'الوقت المفضل*',
      },
      placeholderTestDriveDate: {
        en: 'Preferred date*',
        ar: 'التاريخ المفضل*',
      },
      placeholderTestDriveTime: {
        en: 'Preferred time*',
        ar: 'الوقت المفضل*',
      },
      placeholderFirstName: {
        en: 'First Name*',
        ar: 'الاسم الأول',
      },
      placeholderLastName: {
        en: 'Last Name*',
        ar: 'اسم العائلة',
      },
      placeholderEmail: {
        en: 'Email*',
        ar: 'البريد الالكتروني',
      },
      placeholderMobileNumber: {
        en: 'Mobile Number*',
        ar: 'رقم الجوال',
      },
      placeholderComments: {
        en: 'Comments',
        ar: 'تعليقات',
      },
      placeholderSelectDealership: {
        en: 'Preferred Dealership*',
        ar: 'الوكيل المفضّل',
      },
      privacyTitle: {
        en: 'Privacy statement & legal disclaimer',
        ar: 'بيان الخصوصية وإخلاء المسؤولية القانونية',
      },
      privacyText: {
        en: 'I acknowledge and understand that my information will be shared with General Motors, its affiliates, dealer network or other parties are required by law for compliance, safety campaigns, government inquiries, or similar legal process. My information may also be shared for product research and development purposes, and to manage customer relationships to provide support. GM’s Privacy Statement addresses how GM handles the personal information shared with us.',
        ar: 'أقر وأتفهم بأنة سيتم مشاركة معلوماتي مع شركة جنرال موتورز، والشركات التابعة لها، وشبكة الوكلاء أو الأطراف الأخرى بموجب القانون للامتثال وحملات السلامة واستفسارات الحكومية وأي إجراء قانوني مماثل. وقد تتم مشاركة معلوماتي أيضًا لأغراض البحث وتطوير المنتجات ، وإدارة علاقة العملاء لتوفير الدعم اللازم. يوضح بيان خصوصية جنرال موتورز على موقعنا كيفية تعامل جنرال موتورز مع المعلومات الشخصية التي تمت مشاركتها معنا.',
      },
      privacyReadMore: {
        en: 'Read more',
        ar: 'اقرأ المزيد',
      },
      privacyMarketingConsent: {
        en: 'I wish to receive any marketing information or have my information shared with third parties for purposes of providing me with marketing information.',
        ar: 'أرغب في تلقي معلومات تسويقية أو مشاركة معلوماتي مع جهات خارجية لغاية تزويدي بمعلومات تسويقية',
      },
      buttonSend: {
        en: 'Send Configuration',
        ar: 'إرسال التكوين',
      },
      buttonSending: {
        en: 'Submitting...',
        ar: 'تقديم...',
      },
      buttonSent: {
        en: 'Sent!',
        ar: 'مرسل!',
      },
      buttonRetry: {
        en: 'Retry',
        ar: 'إعادة المحاولة',
      },
      buttonClose: {
        en: 'Okay, Got it',
        ar: 'حسنًا، فهمت',
      },
      successTitle: {
        en: 'Saved',
        ar: 'محفوظ',
      },
      successLabelModel: {
        en: 'Model Name',
        ar: 'اسم النموذج',
      },
      successLabelVariant: {
        en: 'Variant Name',
        ar: 'اسم البديل',
      },
      successLabelName: {
        en: 'Name',
        ar: 'اسم',
      },
      successLabelEmail: {
        en: 'Email*',
        ar: 'البريد الالكتروني',
      },
      successLabelMobile: {
        en: 'Mobile Number*',
        ar: 'رقم الجوال',
      },
      qrTitle: {
        en: 'Your Unique Configuration QR',
        ar: 'رمز الاستجابة السريعة لتكوينك',
      },
      qrDescription: {
        en: 'Show this QR code to your nearest dealer to access your saved configuration.',
        ar: 'أظهر رمز الاستجابة السريعة هذا لتاجر التجزئة الأقرب للوصول إلى التكوين المحفوظ.',
      },
      qrNoteLabel: {
        en: 'Note:',
        ar: 'ملاحظة:',
      },
      qrNote: {
        en: 'Only authorized dealers can view this configuration.',
        ar: 'يمكن للوكلاء المعتمدين فقط عرض هذا التكوين.',
      },
      qrDownload: {
        en: 'Download QR',
        ar: 'تحميل QR',
      },
      qrSave: {
        en: 'Save QR',
        ar: 'حفظ QR',
      },
      errorTitle: {
        en: 'Submission Failed',
        ar: 'فشل التقديم',
      },
      errorMessage: {
        en: 'We encountered an error, please try again.',
        ar: 'واجهنا خطأ، يرجى المحاولة مرة أخرى.',
      },
    },
    featureGroups: {
      exteriorDesign: {
        en: 'Exterior Design & Styling',
        ar: 'التصميم الخارجي والتصميم',
      },
      interiorComfort: {
        en: 'Interior Comfort & Features',
        ar: 'الراحة والميزات الداخلية',
      },
      technologyConvenience: {
        en: 'Technology & Convenience',
        ar: 'التكنولوجيا والراحة',
      },
      safetyAssistance: {
        en: 'Safety & Driver Assistance',
        ar: 'السلامة ومساعدة السائق',
      },
    },
    sidePanel: {
      menu: { en: 'Main Menu', ar: 'القائمة الرئيسية' },
      search: { en: 'Search', ar: 'بحث' },
      settings: { en: 'Settings', ar: 'الإعدادات' },
      profile: { en: 'Profile', ar: 'الملف الشخصي' },
      notifications: { en: 'Notifications', ar: 'الإشعارات' },
      help: { en: 'Help & Support', ar: 'المساعدة والدعم' },
      filter: { en: 'Filter Options', ar: 'خيارات التصفية' },
      favorites: { en: 'Favorites', ar: 'المفضلة' },
      history: { en: 'History', ar: 'التاريخ' },
      tools: { en: 'Tools', ar: 'الأدوات' },
      variants: { en: 'Variants', ar: 'الأنواع' },
      exteriorColor: { en: 'Exterior Color', ar: 'لون الهيكل' },
      interiorColor: { en: 'Interior Color', ar: 'ألوان المقصورة' },
      features: { en: 'Features', ar: 'الميزات' },
      step: { en: 'Step', ar: 'خطوة' },
      openPanel: { en: 'Open Panel', ar: 'فتح اللوحة' },
      closePanel: { en: 'Close Panel', ar: 'إغلاق اللوحة' },
    },
    landscape: {
      message: {
        en: 'Please rotate your device to portrait mode',
        ar: 'يرجى تدوير جهازك إلى الوضع الرأسي',
      },
      subtitle: {
        en: 'For the best experience, please turn your device upright.',
        ar: 'للحصول على أفضل تجربة، يرجى إمساك جهازك بشكل رأسي.',
      },
    },
    cameraViewToggle: {
      ext: { en: 'Ext', ar: 'خارجي' },
      int: { en: 'Int', ar: 'داخلي' },
      dualTone: { en: 'Dual-tone', ar: 'لون مزدوج' },
    },
    bottomDrawer: {
      variants: { en: 'Variants', ar: 'الأنواع' },
      interactions: { en: 'Interactions', ar: 'التفاعلات' },
      accessories: { en: 'Options & Accessories', ar: 'الإكسسوارات' },
      features: { en: 'Features', ar: 'الميزات' },
      highlights: { en: 'Highlights', ar: 'الميزات البارزة' },
      moreOptions: { en: 'More Options', ar: 'المزيد من الخيارات' },
      colorSelector: { en: 'Color Selector', ar: 'محدد اللون' },
      exteriorColor: { en: 'Exterior Color', ar: 'لون الهيكل' },
      interiorColor: { en: 'Interior Color', ar: 'لون المقصورة' },
      wheels: { en: 'Wheels', ar: 'العجلات' },
      roofs: { en: 'Roofs', ar: 'الأسقف' },
      performance: { en: 'Performance', ar: 'الأداء' },
      packages: { en: 'Packages', ar: 'الحزم' },
      chargingOptions: { en: 'Charging Options', ar: 'خيارات الشحن' },
      safetyServices: { en: 'Safety & Services', ar: 'السلامة والخدمات' },
      expand: { en: 'Expand', ar: 'توسيع' },
      minimize: { en: 'Minimize', ar: 'تصغير' },
      freeRoamView: { en: 'Free Roam View', ar: 'عرض التجوال الحر' },
      featureView: { en: 'Featured View', ar: 'العرض المميز' },
    },
    qr: {
      scan: { en: 'Scan QR', ar: 'امسح رمز الاستجابة السريعة' },
      scanWithPhone: {
        en: 'Scan with your phone to view in your Space',
        ar: 'امسح باستخدام هاتفك لعرضه في مساحتك',
      },
    },
    share: {
      title: { en: 'Share Configuration', ar: 'مشاركة التكوين' },
      description: {
        en: 'Share your vehicle configuration with others',
        ar: 'شارك تكوين سيارتك مع الآخرين',
      },
      twitterTitle: {
        en: 'Check out my Chevrolet Traverse configuration!',
        ar: 'شاهد تكوين سيارتي شيفروليه ترافيرس!',
      },
      whatsappTitle: {
        en: 'Check out my Chevrolet Traverse configuration!',
        ar: 'شاهد تكوين سيارتي شيفروليه ترافيرس!',
      },
      linkedinTitle: {
        en: 'My Chevrolet Traverse Configuration',
        ar: 'تكويني لسيارة شيفروليه ترافيرس',
      },
      linkedinSummary: {
        en: 'Check out my custom Chevrolet Traverse configuration!',
        ar: 'شاهد تكويني المخصص لسيارة شيفروليه ترافيرس!',
      },
      emailSubject: {
        en: 'Check out my Chevrolet Traverse Configuration',
        ar: 'شاهد تكوين سيارتي شيفروليه ترافيرس',
      },
      emailBody: {
        en: 'I configured my dream Chevrolet Traverse. Take a look:',
        ar: 'قمت بتكوين سيارة شيفروليه ترافيرس المثالية. ألق نظرة:',
      },
      linkLabel: { en: 'Or copy link:', ar: 'أو انسخ الرابط:' },
      copied: {
        en: 'Copied',
        ar: 'تم نسخ الرابط إلى الحافظة!',
      },
      copy: { en: 'Copy', ar: 'نسخ' },
      saveAndShare: { en: 'Save & Share', ar: 'حفظ ومشاركة' },
      copyLink: { en: 'Copy link', ar: 'نسخ الرابط' },
      facebook: { en: 'Facebook', ar: 'Facebook' },
      twitter: { en: 'Twitter', ar: 'Twitter' },
      gmail: { en: 'Gmail', ar: 'Gmail' },
      whatsapp: { en: 'Whatsapp', ar: 'Whatsapp' },
    },
    topBar: {
      matchingVehiclesFound: {
        en: 'Matching Vehicles Found',
        ar: 'تم العثور على المركبات المطابقة',
      },
    },
    bottomBar: {
      priceLabel: { en: 'ex showroom price', ar: 'سعر صالة العرض' },
      leads: { en: 'Save', ar: 'حفظ' },
      findLocalMatches: {
        en: 'Find Local Matches',
        ar: 'اعثر على التطابقات المحلية',
      },
      save: { en: 'Save', ar: 'حفظ' },
      item: { en: 'Item', ar: 'العنصر' },
      items: { en: 'Items', ar: 'عناصر' },
      totalToPay: { en: 'Total to pay', ar: 'الإجمالي للدفع' },
      bookTestDrive: { en: 'Save', ar: 'حفظ' },
      requestQuote: { en: 'Request a Quote', ar: 'طلب عرض سعر' },
      downloadBrochure: { en: 'Download Brochure', ar: 'تحميل الكتيب' },
    },
    priceSummary: {
      title: { en: 'Price Summary', ar: 'ملخص السعر' },
      enterLocation: { en: 'Enter Location', ar: 'أدخل الموقع' },
      selectCountry: { en: 'Location', ar: 'الموقع' },
      selectCity: { en: 'Location', ar: 'الموقع' },
      note: {
        en: 'Note : Prices might vary by state and all prices listed are on road price, T&C apply.',
        ar: 'ملاحظة: قد تختلف الأسعار حسب الولاية وجميع الأسعار المذكورة هي الأسعار على الطريق، تطبق الشروط والأحكام.',
      },
      breakdown: { en: 'Price Breakdown', ar: 'تفصيل السعر' },
      color: { en: 'Color', ar: 'اللون' },
      variant: { en: 'Variant', ar: 'الفئة' },
      included: { en: 'Included', ar: 'مشمول' },
      total: { en: 'Total', ar: 'الإجمالي' },
    },
    featureDialog: {
      playPause: { en: 'Play-Pause', ar: 'تشغيل-إيقاف' },
    },
    selectDealership: {
      title: { en: 'Select a Dealer', ar: 'اختر وكيلاً' },
      subtitle: {
        en: 'Please select a dealer to find local matches similar to your configuration',
        ar: 'يرجى اختيار وكيل للعثور على سيارات مطابقة لتكوينك في منطقتك',
      },
      city: { en: 'UAE', ar: 'الإمارات' },
      dealersIn: { en: 'Dealers in', ar: 'وكلاء في' },
      dealersInCity: { en: 'Dealers in {{city}}', ar: 'وكلاء في {{city}}' },
      availableInLocations: {
        en: 'Available in {{count}} locations of {{city}}',
        ar: 'متوفرة في {{count}} مواقع في {{city}}',
      },
      proceed: {
        en: 'Select Dealer and Proceed to Configurator',
        ar: 'اختر الوكيل وتابع إلى المتكون',
      },
    },
    countryNames: {
      UAE: { en: 'UAE', ar: 'الإمارات' },
      KSA: { en: 'KSA', ar: 'السعودية' },
      KW: { en: 'Kuwait', ar: 'الكويت' },
      default: { en: 'UAE', ar: 'الإمارات' },
    },
    localMatches: {
      exterior: { en: 'Exterior', ar: 'خارجي' },
      interior: { en: 'Interior', ar: 'داخلي' },
      dualTone: { en: 'Dual-tone', ar: 'لون مزدوج' },
      yourConfiguration: { en: 'Current Configuration', ar: 'التكوين الحالي' },
      viewConfiguration: {
        en: 'View your configuration details',
        ar: 'عرض تفاصيل تكوينك',
      },
      yourBuildDetails: { en: 'Your Build Details', ar: 'تفاصيل بنائك' },
      options: { en: 'Options', ar: 'الخيارات' },
      save: { en: 'Save', ar: 'حفظ' },
      dealersIn: { en: 'Dealers in', ar: 'وكلاء في' },
      changeDealer: { en: 'Change Dealer', ar: 'تغيير الوكيل' },
      carsAvailable: {
        en: 'Cars Available at the Selected Dealership',
        ar: 'السيارات المتوفرة لدى الوكيل المختار',
      },
      matchesFound: { en: 'Matches found', ar: 'تطابق تم العثور عليه' },
      startingFrom: { en: 'Starting from', ar: 'يبدأ من' },
      getQuote: { en: 'Proceed', ar: 'احصل على عرض سعر' },
      viewDifferences: { en: 'View Differences', ar: 'عرض الاختلافات' },
      match: { en: 'Match', ar: 'تطابق' },
      closestMatchFound: {
        en: 'Closest Match Found',
        ar: 'أقرب تطابق تم العثور عليه',
      },
      buildDetails: { en: 'Build Details', ar: 'تفاصيل التكوين' },
      trim: { en: 'Trim', ar: 'الفئة' },
      matchScoreTooltip: {
        en: 'This score indicates how closely this vehicle matches your configuration.',
        ar: 'يشير هذا النتيجة إلى مدى تطابق هذه السيارة مع تكوينك.',
      },
      exactMatch: { en: 'Exact Match', ar: 'تطابق تام' },
      similarMatch: { en: 'Close Match', ar: 'تطابق قريب' },
      availableNow: { en: 'Available Now', ar: 'متوفر الآن' },
      whatYouConfigured: { en: 'What you configured', ar: 'ما قمت بتكوينه' },
      matchingInStock: { en: 'Matching vehicle available in stock', ar: 'مركبة مطابقة متوفرة في المخزون' },
      noMatches: {
        en: 'No matching vehicles found in your area.',
        ar: 'لم يتم العثور على سيارات مطابقة في منطقتك.',
      },
      closeMatchDetails: { en: 'Close Match Details', ar: 'تفاصيل التطابق القريب' },
      matchesYourSelection: { en: 'Matches your selection', ar: 'يطابق اختيارك' },
      sameAsWhatYouSelected: { en: 'Same as what you selected', ar: 'نفس ما اخترته' },
      replacesYourSelection: { en: 'Replaces your selection', ar: 'يستبدل اختيارك' },
      selectionNotIncluded: { en: 'Selection not included', ar: 'الاختيار غير مشمول' },
      includedInThisVehicle: { en: 'Included in this vehicle', ar: 'مشمول في هذه المركبة' },
      additionalFeatureAlreadyIncluded: { en: 'Additional feature already included', ar: 'ميزة إضافية مشمولة بالفعل' },
      stockDisclaimer: { en: 'Available stock may include extra features not selected in your original configuration.', ar: 'قد تشمل المركبات المتاحة ميزات إضافية لم تختارها في تكوينك الأصلي.' },
      additionalInstalledOptionsLegend: { en: 'Included in this vehicle', ar: 'مشمول في هذه المركبة' },
      vehicleDetails: { en: 'Vehicle Details', ar: 'تفاصيل المركبة' },
      installedOptionsTitle: { en: 'Comes with vehicle', ar: 'يأتي مع المركبة' },
      additionalInstalledOptionsSubtitle: { en: 'Additional Installed Options:', ar: 'الخيارات المركبة الإضافية:' },
      specTrim: { en: 'Trim', ar: 'الفئة' },
      specExteriorColor: { en: 'Exterior Color', ar: 'اللون الخارجي' },
      specInteriorColor: { en: 'Interior Color', ar: 'اللون الداخلي' },
      specWheels: { en: 'Wheels', ar: 'العجلات' },
      specPackage: { en: 'Package', ar: 'الحزمة' },
      title: {
        en: 'Configurations Found',
        ar: 'تكوينات تم العثور عليها',
      },
      message: {
        en: 'We Found a few local matches similar to your current configuration. Click to view Matches',
        ar: 'وجدنا بعض التطابقات المحلية المشابهة لتكوينك الحالي. انقر لعرض التطابقات',
      },
    },
    trim: {
      selection: { en: 'Trim Selection', ar: 'اختيار الفئة' },
    },
    paymentPage: {
      exteriorColor: { en: 'Exterior Color', ar: 'لون الهيكل' },
      interiorColor: { en: 'Interior Color', ar: 'لون المقصورة' },
      accessory: { en: 'Accessory', ar: 'ملحق' },
      closePayment: { en: 'Close', ar: 'إغلاق' },
    },
    packageModal: {
      includes: { en: 'Includes:', ar: 'يشمل:' },
      of: { en: 'of', ar: 'من' },
      totalPriceChange: {
        en: 'Total Price Change:',
        ar: 'إجمالي تغيير السعر:',
      },
      item: { en: 'Item', ar: 'غرض' },
      items: { en: 'Items', ar: 'أغراض' },
      addPackage: { en: 'Add Package', ar: 'إضافة الحزمة' },
      noThanks: { en: 'No Thanks', ar: 'لا شكراً' },
      alreadyApplied: { en: 'Already Applied', ar: 'مُطبّق بالفعل' },
    },
    changesRequired: { en: 'Changes Required', ar: 'التغييرات المطلوبة' },
    changesRequiredDescription: {
      en: 'The package you selected conflicts with your current selections. Please review the changes below.',
      ar: 'الحزمة التي اخترتها تتعارض مع اختياراتك الحالية. يرجى مراجعة التغييرات أدناه.',
    },
    itemsThatWillBeRemoved: {
      en: 'Items that will be removed',
      ar: 'العناصر التي سيتم إزالتها',
    },
    itemsThatWillBeAdded: {
      en: 'Items that will be added',
      ar: 'العناصر التي سيتم إضافتها',
    },
    applyChanges: { en: 'Apply Changes', ar: 'تطبيق التغييرات' },
    previewFeature: { en: 'Preview Feature', ar: 'معاينة الميزة' },
    exploreFeatures: { en: 'Explore Features', ar: 'استكشف الميزات' },
    buildAndPrice: { en: 'Build & Price', ar: 'البناء والسعر' },
    features: {
      preview: { en: 'Preview Feature', ar: 'معاينة المميزات' },
      playAll: { en: 'PLAY ALL', ar: 'تشغيل الكل' },
      title: { en: 'Features', ar: 'المميزات' },
    },
    header: {
      localMatches: { en: 'Local\nMatches', ar: 'التطابقات\nالمحلية' },
      matchingVehicles: { en: 'Matching vehicles', ar: 'مركبات مطابقة' },
      configurationsFound: { en: 'Configurations Found', ar: 'تكوينات تم العثور عليها' },
    },
    configPanel: {
      playAll: { en: 'Play All', ar: 'تشغيل الكل' },
      pause: { en: 'Pause', ar: 'إيقاف مؤقت' },
      exteriorColors: { en: 'Exterior Colors', ar: 'ألوان الهيكل الخارجي' },
      interiorColors: { en: 'Interior Colors', ar: 'ألوان الداخلية' },
      roofOptions: { en: 'Roof Options', ar: 'خيارات السقف' },
      interiorOptions: { en: 'Interior Options', ar: 'خيارات الداخلية' },
      exteriorAccessories: { en: 'Exterior Accessories', ar: 'إكسسوارات خارجية' },
      noAdditionalOptions: { en: 'No additional options available for the selected trim.', ar: 'لا توجد خيارات إضافية متاحة للفئة المختارة.' },
      noFilters: { en: 'No filters available.', ar: 'لا توجد فلاتر متاحة.' },
      noVariantsMatch: { en: 'No trims match the selected filters.', ar: 'لا توجد فئات تطابق الفلاتر المختارة.' },
      configurationBreakdown: { en: 'Configuration Breakdown', ar: 'تفاصيل التكوين' },
      yourConfiguration: { en: 'Your Configuration', ar: 'تكوينك' },
      trim: { en: 'Trim', ar: 'الفئة' },
      total: { en: 'Total', ar: 'الإجمالي' },
    },
    conflictDialog: {
      description: { en: 'In order to apply this, the following item(s) will need to be removed due to compatibility constraints. Please review the item(s) below and proceed with your change.', ar: 'لتطبيق هذا، يجب إزالة العناصر التالية بسبب قيود التوافق. يرجى مراجعة العناصر أدناه والمتابعة بتغييرك.' },
    },
    viewport: {
      changeBackground: { en: 'Change Background', ar: 'تغيير الخلفية' },
      selectLanguage: { en: 'Switch Language (عربي)', ar: 'تبديل اللغة (EN)' },
      menu: { en: 'Menu', ar: 'القائمة' },
      exploreFeatures: { en: 'Explore Features', ar: 'استكشف الميزات' },
    },
  },
  dealers: {
    UAE: [
      {
        id: 0,
        country: 'UAE',
        value: 'UAE',
        dealerId: '122255',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Quoz 3 Industrial Area Sheikh Zayed Road, Dubai',
          ar: 'الكندي للسيارات - القوز 3، المنطقة الصناعية، طريق الشيخ زايد، دبي',
        },
      },
      {
        id: 1,
        country: 'UAE',
        value: 'UAE',
        dealerId: '256427',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Double Cola Road, Sharjah',
          ar: 'الكندي للسيارات - طريق دبل كولا، الشارقة',
        },
      },
      {
        id: 2,
        country: 'UAE',
        value: 'UAE',
        dealerId: '256428',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Madhab Mohammad Bin Mattar Street, Fujairah',
          ar: 'الغاندي للسيارات - شارع مذهب محمد بن مطر، الفجيرة',
        },
      },
      {
        id: 3,
        country: 'UAE',
        value: 'UAE',
        dealerId: '256429',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Nadiyah Sheikh Mohammed Bin Salem Road, Ras Al Khaimah',
          ar: 'الكندي للسيارات - الندية طريق الشيخ محمد بن سالم، رأس الخيمة',
        },
      },
      {
        id: 4,
        country: 'UAE',
        value: 'UAE',
        dealerId: '301597',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Itihad Road - showroom , Al Khabaisi, Deira, Dubai',
          ar: 'الكندي للسيارات - طريق الاتحاد - صالة عرض , الخبيصي, ديرة, دبي',
        },
      },
      {
        id: 8,
        country: 'UAE',
        value: '',
        dealerId: '334821',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi - Mirdiff City Center',
          ar: 'الغاندي - مردف سيتي سنتر',
        },
      },
      {
        id: 5,
        country: 'UAE',
        value: 'UAE',
        dealerId: '323482',
        dealerName: 'Bin Hamoodah Auto',
        label: {
          en: 'Bin Hamoodah Auto - Madinat Zayed, Al Dhafra',
          ar: 'بن حمودة للسيارات - مدينة زايد، الظفرة',
        },
      },
      {
        id: 6,
        country: 'UAE',
        value: 'UAE',
        dealerId: '122552',
        dealerName: 'Bin Hamoodah Auto',
        label: {
          en: 'Bin Hamoodah Auto - Al Ain',
          ar: 'بن حمودة للسيارات - العين',
        },
      },
      {
        id: 7,
        country: 'UAE',
        value: 'UAE',
        dealerId: '122233',
        dealerName: 'Bin Hamoodah Auto',
        label: {
          en: 'Bin Hamoodah Auto - Abu Dhabi Main',
          ar: 'بن حمودة للسيارات - أبوظبي الرئيسية',
        },
      },
    ],
    KSA: [
      {
        id: 0,
        country: 'KSA',
        value: 'KSA',
        dealerId: '307261',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Al Aziziyah Madina Road, Jeddah',
          ar: 'الجميح للسيارات - العزيزية طريق المدينة، جدة',
        },
      },
      {
        id: 1,
        country: 'KSA',
        value: 'KSA',
        dealerId: '164034',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Hail City King Abdullah Road. Hail',
          ar: 'الجميح للسيارات - مدينة حائل طريق الملك عبدالله. يشيد',
        },
      },
      {
        id: 2,
        country: 'KSA',
        value: 'KSA',
        dealerId: '164035',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Alshlhoub King Abdullah Road, Al Jouf',
          ar: 'الجميح للسيارات - الشلهوب طريق الملك عبدالله، الجوف',
        },
      },
      {
        id: 3,
        country: 'KSA',
        value: 'KSA',
        dealerId: '307271',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Qassim King Abdulaziz Road, Buraidah',
          ar: 'الجميح للسيارات - القصيم طريق الملك عبد العزيز، بريدة',
        },
      },
      {
        id: 4,
        country: 'KSA',
        value: 'KSA',
        dealerId: '260921',
        dealerName: 'Aljomaih Auto',
        label: {
          en: 'Aljomaih Auto - Al Jededah Road, Arar',
          ar: 'الجميح للسيارات - طريق الجديدة، عرعر',
        },
      },
    ],
    KW: [
      {
        id: 0,
        country: 'KW',
        value: 'KW',
        dealerId: '122620',
        dealerName: 'Alamana Auto',
        label: {
          en: 'Alamana Auto - Al Rai 4th Ring Road, Al Rai',
          ar: 'الامانة للسيارات - الري الطريق الدائري الرابع، الري',
        },
      },
      {
        id: 1,
        country: 'KW',
        value: 'KW',
        dealerId: '174979',
        dealerName: 'Alamana Auto',
        label: {
          en: 'Alamana Auto - Fahaheel Industrial Area Dabbous Street, Fahaheel',
          ar: 'الامانة للسيارات - الفحيحيل الصناعية شارع الدبوس، الفحيحيل',
        },
      },
    ],
    BHD: [
      {
        id: 0,
        country: 'BHD',
        value: 'BHD',
        dealerId: '122215',
        dealerName: 'National Motor Company W.L.L',
        label: {
          en: 'National Motor Company W.L.L, Al Qarya 475 Shk. Jaber Al Subah Hwy',
          ar: 'الشركة الوطنية للسيارات ذ.م.م، القرية 475 شارع الشيخ. طريق جابر الصباح',
        },
      },
    ],
    IQD: [
      {
        id: 0,
        country: 'IQD',
        value: 'IQD',
        dealerId: '295876',
        dealerName: 'MAC International FZE',
        label: {
          en: 'MAC International FZE, Al-Karada Sadoun Street',
          ar: 'شركة ماك الدولية (منطقة حرة)، شارع الكرادة سعدون',
        },
      },
      {
        id: 1,
        country: 'IQD',
        value: 'IQD',
        dealerId: '295879',
        dealerName: 'MAC International FZE',
        label: {
          en: 'MAC International FZE, Kurdistan District 100 m Street',
          ar: 'ماك إنترناشونال إف زي إي، منطقة كردستان، شارع ١٠٠ متر',
        },
      },
    ],
    LBP: [
      {
        id: 0,
        country: 'LBP',
        value: 'LBP',
        dealerId: '122226',
        dealerName: 'IMPEX',
        label: {
          en: 'IMPEX -  Badaro, Near the National Museum , Beirut',
          ar: 'إمبكس - بدارو، بالقرب من المتحف الوطني، بيروت',
        },
      },
    ],
    QAR: [
      {
        id: 0,
        country: 'QAR',
        value: 'QAR',
        dealerId: '274766',
        dealerName: 'Jaidah',
        label: {
          en: 'Jaidah Square Showroom - Al Matar Street Umm Ghuwallina, Doha',
          ar: 'صالة عرض "جايدة سكوير" - شارع المطار، أم غويلينة، الدوحة',
        },
      },
    ],
    OMR: [
      {
        id: 0,
        country: 'OMR',
        value: 'OMR',
        dealerId: '122219',
        dealerName: 'Oman Trading Establisment',
        label: {
          en: 'Oman Trading Establisment LLC, Ghalla Al Maardh Street',
          ar: 'مؤسسة عمان التجارية ش.م.م، شارع غلا المعرض',
        },
      },
      {
        id: 1,
        country: 'OMR',
        value: 'OMR',
        dealerId: '234217',
        dealerName: 'Oman Trading Establisment',
        label: {
          en: 'Oman Trading Establisment LLC, Al Farq Street',
          ar: 'مؤسسة عمان التجارية ذ.م.م، شارع الفرق',
        },
      },
      {
        id: 2,
        country: 'OMR',
        value: 'OMR',
        dealerId: '260896',
        dealerName: 'Oman Trading Establisment',
        label: {
          en: 'Oman Trading Establisment LLC, Hail Al Shumaliah Street',
          ar: 'مؤسسة عمان التجارية ذ.م.م، شارع حيل الشمالية',
        },
      },
    ],
    JOD: [
      {
        id: 0,
        country: 'JOD',
        value: 'JOD',
        dealerId: '189129',
        dealerName: 'Leading Vehicles',
        label: {
          en: 'The Leading Vehicles Co. Ltd, Al Rawabi',
          ar: 'شركة المركبات الرائدة المحدودة، الروابي',
        },
      },
    ],
    default: [
      {
        id: 0,
        country: 'UAE',
        value: 'UAE',
        dealerId: '122255',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Quoz 3 Industrial Area Sheikh Zayed Road, Dubai',
          ar: 'الكندي للسيارات - القوز 3، المنطقة الصناعية، طريق الشيخ زايد، دبي',
        },
      },
      {
        id: 1,
        country: 'UAE',
        value: 'UAE',
        dealerId: '256427',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Double Cola Road, Sharjah',
          ar: 'الكندي للسيارات - طريق دبل كولا، الشارقة',
        },
      },
      {
        id: 2,
        country: 'UAE',
        value: 'UAE',
        dealerId: '256428',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Madhab Mohammad Bin Mattar Street, Fujairah',
          ar: 'الغاندي للسيارات - شارع مذهب محمد بن مطر، الفجيرة',
        },
      },
      {
        id: 3,
        country: 'UAE',
        value: 'UAE',
        dealerId: '256429',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Nadiyah Sheikh Mohammed Bin Salem Road, Ras Al Khaimah',
          ar: 'الكندي للسيارات - الندية طريق الشيخ محمد بن سالم، رأس الخيمة',
        },
      },
      {
        id: 4,
        country: 'UAE',
        value: 'UAE',
        dealerId: '301597',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi Auto - Al Itihad Road - showroom , Al Khabaisi, Deira, Dubai',
          ar: 'الكندي للسيارات - طريق الاتحاد - صالة عرض , الخبيصي, ديرة, دبي',
        },
      },
      {
        id: 8,
        country: 'UAE',
        value: '',
        dealerId: '334821',
        dealerName: 'Al Ghandi Auto',
        label: {
          en: 'Al Ghandi - Mirdiff City Center',
          ar: 'الغاندي - مردف سيتي سنتر',
        },
      },
      {
        id: 5,
        country: 'UAE',
        value: 'UAE',
        dealerId: '323482',
        dealerName: 'Bin Hamoodah Auto',
        label: {
          en: 'Bin Hamoodah Auto - Madinat Zayed, Al Dhafra',
          ar: 'بن حمودة للسيارات - مدينة زايد، الظفرة',
        },
      },
      {
        id: 6,
        country: 'UAE',
        value: 'UAE',
        dealerId: '122552',
        dealerName: 'Bin Hamoodah Auto',
        label: {
          en: 'Bin Hamoodah Auto - Al Ain',
          ar: 'بن حمودة للسيارات - العين',
        },
      },
      {
        id: 7,
        country: 'UAE',
        value: 'UAE',
        dealerId: '122233',
        dealerName: 'Bin Hamoodah Auto',
        label: {
          en: 'Bin Hamoodah Auto - Abu Dhabi Main',
          ar: 'بن حمودة للسيارات - أبوظبي الرئيسية',
        },
      },
    ],
  },
  featureFlags: {
    showPriceInPresentation: false,
    showLogo: true,
    showSpecDetailsButton: true,
    useChevroletFont: true,
    showLocalMatches: true,
    showDisclaimerInPresentation: false,
    showPrices: true, // per-item prices on cards + summary breakdown, like Corvette
    showDisplayCarPrice: true, // Toggle to show car price in CarDisplay UI
    showCart: false, // Toggle to show/hide cart button
  },
  // Set mobile/desktop to false to hide that tab on the respective screen size
  // toggleTabs is now variant-specific — see each variant's toggleTabs field above
  config: {
    // Display currency + USD conversion factor per region, keyed by the
    // `country` URL parameter (local = usd * fx). Prices were re-derived
    // from the AED figure: usd = AED / 3.68, then usd * fx per country.
    regions: {
      KSA: { label: 'KSA', currency: 'SAR', fx: 3.75 },
      UAE: { label: 'UAE', currency: 'AED', fx: 3.68 },
      OMR: { label: 'Oman', currency: 'OMR', fx: 0.39 },
      BHD: { label: 'Bahrain', currency: 'BHD', fx: 0.38 },
      QAR: { label: 'Qatar', currency: 'QAR', fx: 3.64 },
      JOD: { label: 'Jordan', currency: 'JOD', fx: 0.71 },
      KW: { label: 'Kuwait', currency: 'KWD', fx: 0.31 },
      LBP: { label: 'Lebanon', currency: 'USD', fx: 1 }, // GM quotes Lebanon in USD
      IQD: { label: 'Iraq', currency: 'USD', fx: 1 }, // priced in USD, like Lebanon
      default: { label: 'UAE', currency: 'AED', fx: 3.68 },
    },
    externalAnalytics: {
      vehicleType: 'suv',
      brand: 'chevrolet',
      provider: 'adobe',
      modelName: 'traverse',
    },
    // Lead-side model name — 1.0's `config.model`, which is a lead label
    // distinct from 2.0's `config.model` (the models[] key).
    leadModel: 'traverse',
    // Dial code (prefixed onto mobile_number) and Salesforce lead country
    // code (metadome_country_code), keyed by the `country` URL parameter.
    countryCodes: {
      UAE: {
        code: '+971',
        leadCode: 'AE',
      },
      KSA: {
        code: '+966',
        leadCode: 'SA',
      },
      KW: {
        code: '+965',
        leadCode: 'KW',
      },
      BHD: {
        code: '+973',
        leadCode: 'BH',
      },
      IQD: {
        code: '+964',
        leadCode: 'IQ',
      },
      LBP: {
        code: '+961',
        leadCode: 'LB',
      },
      OMR: {
        code: '+968',
        leadCode: 'OM',
      },
      QAR: {
        code: '+974',
        leadCode: 'QA',
      },
      JOD: {
        code: '+962',
        leadCode: 'JO',
      },
      default: {
        code: '+971',
        leadCode: 'AE',
      },
    },
    model: 'Traverse',
    modelName: 'Traverse',
    pageTitle: 'Traverse Configurator',
    client: 'GM',
    brand: 'chevrolet',
    modelId: 'CHTRAC1',
    // modelYear: 2025,
    configurationId: 'l25zrwex1u93',
    presentation: {
      video: 'videos/2378/presentation_video_1.webm',
      loadingImage: 'images/2378/sliderImage.webp',
      transitionImage: 'images/2378/transition_logo.png',
      headerLogoKeepColor: true,
      keyHighlights: [
        {
          index: 0,
          show: true,
          title: {
            en: '',
            ar: '',
          },
          value: {
            en: '328 HP',
            ar: '328 حصان',
          },
          unit: '',
        },
        {
          index: 1,
          show: true,
          title: {
            en: 'Torque',
            ar: 'عزم الدوران',
          },
          value: {
            en: '442 NM',
            ar: '442 نيوتن-متر',
          },
          unit: '',
        },
        {
          index: 2,
          show: true,
          title: {
            en: 'Turbo Engine',
            ar: 'Turbo محرك',
          },
          value: {
            en: '2.5L',
            ar: '2.5 لتر',
          },
          unit: '',
        },
      ],
    },
  },
  saveFormConfig: {
    fields: [
      {
        id: 'firstName',
        type: 'text',
        required: true,
        labelKey: 'saveDialog.labelFirstName',
        placeholderKey: 'saveDialog.placeholderFirstName',
      },
      {
        id: 'lastName',
        type: 'text',
        required: true,
        labelKey: 'saveDialog.labelLastName',
        placeholderKey: 'saveDialog.placeholderLastName',
      },
      {
        id: 'email',
        type: 'email',
        required: true,
        labelKey: 'saveDialog.labelEmail',
        placeholderKey: 'saveDialog.placeholderEmail',
        visibility: ['email', 'test-drive', 'callback'],
      },
      {
        id: 'phone',
        type: 'phone',
        required: true,
        labelKey: 'saveDialog.labelMobileNumber',
        placeholderKey: 'saveDialog.placeholderMobileNumber',
        visibility: ['whatsapp', 'test-drive', 'callback'],
      },
      {
        id: 'model',
        type: 'select',
        required: true,
        labelKey: 'saveDialog.labelModel',
        placeholderKey: 'saveDialog.labelModel',
        optionsSource: 'models',
        visibility: ['test-drive', 'callback'],
      },
      {
        id: 'dealer',
        type: 'select',
        required: true,
        labelKey: 'saveDialog.labelDealership',
        placeholderKey: 'saveDialog.placeholderSelectDealership',
        optionsSource: 'dealers',
        visibility: [
          'test-drive',
          'callback',
          'whatsapp',
          'email',
        ],
        // 1.0's save forms show the dealership dropdown but do not gate
        // submission on it; only the booking forms require it.
        requiredFor: [
          'test-drive',
          'callback',
        ],
      },
      {
        id: 'testDriveDate',
        type: 'date',
        required: true,
        labelKey: 'saveDialog.labelTestDriveDate',
        placeholderKey: 'saveDialog.placeholderTestDriveDate',
        visibility: [
          'test-drive',
        ],
      },
      {
        id: 'testDriveTime',
        type: 'time',
        required: true,
        labelKey: 'saveDialog.labelTestDriveTime',
        placeholderKey: 'saveDialog.placeholderTestDriveTime',
        visibility: [
          'test-drive',
        ],
      },
      {
        id: 'comments',
        type: 'textarea',
        required: false,
        labelKey: 'saveDialog.labelComments',
        placeholderKey: 'saveDialog.placeholderComments',
        visibility: ['test-drive', 'callback'],
      },
    ],
  },
  externalScript: {
    dev: {
      head: {
        links: [
          {
            snippet:
              'https://assets.adobedtm.com/ea8c57fea068/636ca1404ad1/launch-bea0833819b4-development.min.js',
            iframe: true,
            standalone: true,
          },
          {
            snippet: 'https://assets.gm.com/responsive-iframe.min.js',
            iframe: true,
            standalone: true,
          },
          {
            snippet:
              'https://cmp.osano.com/3j6afV3OqT/4661232f-0324-44a1-bbfd-07fe470494c7/osano.js',
            iframe: false,
            standalone: true,
          },
        ],
        snippets: [
          {
            snippet: `<!-- Meta Pixel Code -->
<script>
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(argum
ents)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,
document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2090290248171811');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1"
style="display:none"
src="https://www.facebook.com/tr?
id=2090290248171811&ev=PageView&noscript=1"
/></noscript>
<!-- End Meta Pixel Code -->
        `,
            iframe: true,
            standalone: true,
          },
        ],
      },
    },
    staging: {
      head: {
        links: [
          {
            snippet:
              'https://assets.adobedtm.com/ea8c57fea068/636ca1404ad1/launch-77110a86d4ec-staging.min.js',
            iframe: true,
            standalone: true,
          },
          {
            snippet: 'https://assets.gm.com/responsive-iframe.min.js',
            iframe: true,
            standalone: true,
          },
          {
            snippet:
              'https://cmp.osano.com/3j6afV3OqT/4661232f-0324-44a1-bbfd-07fe470494c7/osano.js',
            iframe: false,
            standalone: true,
          },
        ],
        snippets: [
          {
            snippet: `<!-- Meta Pixel Code -->
<script>
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(argum
ents)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,
document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2090290248171811');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1"
style="display:none"
src="https://www.facebook.com/tr?
id=2090290248171811&ev=PageView&noscript=1"
/></noscript>
<!-- End Meta Pixel Code -->
        `,
            iframe: true,
            standalone: true,
          },
        ],
      },
    },
    main: {
      head: {
        links: [
          {
            snippet:
              'https://assets.adobedtm.com/ea8c57fea068/636ca1404ad1/launch-85b05c76e071.min.js',
            iframe: true,
            standalone: true,
          },
          {
            snippet: 'https://assets.gm.com/responsive-iframe.min.js',
            iframe: true,
            standalone: true,
          },
          {
            snippet:
              'https://cmp.osano.com/3j6afV3OqT/4661232f-0324-44a1-bbfd-07fe470494c7/osano.js',
            iframe: false,
            standalone: true,
          },
        ],
        snippets: [
          {
            snippet: `<!-- Meta Pixel Code -->
<script>
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(argum
ents)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,
document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '2090290248171811');
fbq('track', 'PageView');
</script>
<noscript><img height="1" width="1"
style="display:none"
src="https://www.facebook.com/tr?
id=2090290248171811&ev=PageView&noscript=1"
/></noscript>
<!-- End Meta Pixel Code -->
        `,
            iframe: true,
            standalone: true,
          },
        ],
      },
    },
  },
  filterOptions: [
    {
      id: 'drivetrain',
      label: { en: 'Drivetrain', ar: 'نظام الدفع' },
      disabled: false,
      type: 'chip' as const,
      key: 'description',
      options: [
        {
          id: 'awd',
          label: { en: 'AWD', ar: 'دفع رباعي' },
          value: 'AWD',
          checked: false,
          subtitle: { en: 'All-Wheel Drive', ar: 'الدفع الرباعي' },
          description: { en: 'Superior traction and handling in all conditions', ar: 'جر وتحكم متفوقان في جميع الظروف' },
        },
        {
          id: 'fwd',
          label: { en: 'FWD', ar: 'دفع أمامي' },
          value: 'FWD',
          checked: false,
          subtitle: { en: 'Front-Wheel Drive', ar: 'الدفع الأمامي' },
          description: { en: 'Efficient everyday performance', ar: 'أداء يومي فعال' },
        },
      ],
    },
    {
      id: 'trim',
      label: { en: 'Trim', ar: 'الطراز' },
      disabled: true,
      type: 'chip' as const,
      key: 'name',
      options: [
        {
          id: 'z71',
          label: { en: 'Z71', ar: 'Z71' },
          value: 'Z71',
          checked: false,
          subtitle: { en: 'Off-Road Ready', ar: 'مستعد للطرق الوعرة' },
          description: { en: 'Advanced Twin-Clutch AWD with off-road capability', ar: 'نظام دفع رباعي متقدم بقدرات الطرق الوعرة' },
        },
        {
          id: 'lt',
          label: { en: 'LT', ar: 'LT' },
          value: 'LT',
          checked: false,
          subtitle: { en: 'Premium Comfort', ar: 'راحة فائقة' },
          description: { en: 'Available in AWD and FWD configurations', ar: 'متاح بتكوينات دفع رباعي وأمامي' },
        },
      ],
    },
  ],
  styleConfig: {
    cssVariables: {
      '--default-font-family': 'Chevy Sans',
      '--bold-font-family': 'Chevy Sans Medium',
      '--brand-primary': '#0077D9',
      '--brand-primary-hover': '#0062BA',
      '--brand-secondary': '#0077D9',
      '--brand-accent': '#0077D9',
      '--brand-accent-hover': '#0066c0',
      '--brand-accent-light': '#dee5f2',
      '--brand-surface': '#f2f2f2',
      '--brand-surface-alt': '#f3f4f6',
      '--brand-text': '#000000',
      '--brand-text-secondary': '#666666',
      '--brand-text-tertiary': '#bebebe',
      '--brand-border': '#e5e7eb',
      '--brand-border-selected': '#0077D9',
      '--brand-card-bg': '#ffffff',
      '--brand-toggle-gradient-from': '#0077D9',
      '--brand-toggle-gradient-to': '#0077D9',
      '--brand-toggle-knob-border': '#09f',
      '--brand-accent-secondary': '#EB212B',
      '--brand-card-radius': '10px',
      '--brand-card-radius-sm': '7px',
      '--brand-card-radius-lg': '12px',
      '--brand-button-radius': '6px',
      '--brand-button-radius-sm': '5px',
      '--brand-pill-radius': '50px',
      '--brand-cta-radius': '8px',
      '--brand-button-border': '#0077D9',
      '--brand-dialog-radius': '11px',
      '--brand-dialog-option-radius': '8px',
    },
  },
} as unknown as UIMetadataComplete;
